import { HcSchedule, TimeSlot } from './hc-schedule.model';

export interface TimezoneInfo {
  name: string;
  countryCode: string;
  abbreviation: string;
  offsetMinutes: number;
  isDst: boolean;
  timestamp: number;
  displayName: string;
  region: string;
}

export const TIMEZONE_DATA: TimezoneInfo[] = [
  {
    "name": "Pacific/Midway",
    "countryCode": "UM",
    "abbreviation": "SST",
    "offsetMinutes": -39600,
    "isDst": false,
    "timestamp": -420645600,
    "region": "Pacific",
    "displayName": "Midway (Pacific -660)"
  },
  {
    "name": "Pacific/Niue",
    "countryCode": "NU",
    "abbreviation": "NUT",
    "offsetMinutes": -39600,
    "isDst": false,
    "timestamp": -173623200,
    "region": "Pacific",
    "displayName": "Niue (Pacific -660)"
  },
  {
    "name": "Pacific/Pago_Pago",
    "countryCode": "AS",
    "abbreviation": "SST",
    "offsetMinutes": -39600,
    "isDst": false,
    "timestamp": -1861879032,
    "region": "Pacific",
    "displayName": "Pago Pago (Pacific -660)"
  },
  {
    "name": "America/Adak",
    "countryCode": "US",
    "abbreviation": "HST",
    "offsetMinutes": -36000,
    "isDst": false,
    "timestamp": 16719994800,
    "region": "America",
    "displayName": "Adak (America -600)"
  },
  {
    "name": "Pacific/Honolulu",
    "countryCode": "US",
    "abbreviation": "HST",
    "offsetMinutes": -36000,
    "isDst": false,
    "timestamp": -712150200,
    "region": "Pacific",
    "displayName": "Honolulu (Pacific -600)"
  },
  {
    "name": "Pacific/Rarotonga",
    "countryCode": "CK",
    "abbreviation": "CKT",
    "offsetMinutes": -36000,
    "isDst": false,
    "timestamp": 667992600,
    "region": "Pacific",
    "displayName": "Rarotonga (Pacific -600)"
  },
  {
    "name": "Pacific/Tahiti",
    "countryCode": "PF",
    "abbreviation": "TAHT",
    "offsetMinutes": -36000,
    "isDst": false,
    "timestamp": -1806674504,
    "region": "Pacific",
    "displayName": "Tahiti (Pacific -600)"
  },
  {
    "name": "Pacific/Marquesas",
    "countryCode": "PF",
    "abbreviation": "MART",
    "offsetMinutes": -34200,
    "isDst": false,
    "timestamp": -1806676920,
    "region": "Pacific",
    "displayName": "Marquesas (Pacific -570)"
  },
  {
    "name": "America/Anchorage",
    "countryCode": "US",
    "abbreviation": "AKST",
    "offsetMinutes": -32400,
    "isDst": false,
    "timestamp": 16719991200,
    "region": "America",
    "displayName": "Anchorage (America -540)"
  },
  {
    "name": "America/Juneau",
    "countryCode": "US",
    "abbreviation": "AKST",
    "offsetMinutes": -32400,
    "isDst": false,
    "timestamp": 16719991200,
    "region": "America",
    "displayName": "Juneau (America -540)"
  },
  {
    "name": "America/Metlakatla",
    "countryCode": "US",
    "abbreviation": "AKST",
    "offsetMinutes": -32400,
    "isDst": false,
    "timestamp": 16719991200,
    "region": "America",
    "displayName": "Metlakatla (America -540)"
  },
  {
    "name": "America/Nome",
    "countryCode": "US",
    "abbreviation": "AKST",
    "offsetMinutes": -32400,
    "isDst": false,
    "timestamp": 16719991200,
    "region": "America",
    "displayName": "Nome (America -540)"
  },
  {
    "name": "America/Sitka",
    "countryCode": "US",
    "abbreviation": "AKST",
    "offsetMinutes": -32400,
    "isDst": false,
    "timestamp": 16719991200,
    "region": "America",
    "displayName": "Sitka (America -540)"
  },
  {
    "name": "America/Yakutat",
    "countryCode": "US",
    "abbreviation": "AKST",
    "offsetMinutes": -32400,
    "isDst": false,
    "timestamp": 16719991200,
    "region": "America",
    "displayName": "Yakutat (America -540)"
  },
  {
    "name": "Pacific/Gambier",
    "countryCode": "PF",
    "abbreviation": "GAMT",
    "offsetMinutes": -32400,
    "isDst": false,
    "timestamp": -1806678012,
    "region": "Pacific",
    "displayName": "Gambier (Pacific -540)"
  },
  {
    "name": "America/Los_Angeles",
    "countryCode": "US",
    "abbreviation": "PST",
    "offsetMinutes": -28800,
    "isDst": false,
    "timestamp": 16719987600,
    "region": "America",
    "displayName": "Los Angeles (America -480)"
  },
  {
    "name": "America/Tijuana",
    "countryCode": "MX",
    "abbreviation": "PST",
    "offsetMinutes": -28800,
    "isDst": false,
    "timestamp": 16719987600,
    "region": "America",
    "displayName": "Tijuana (America -480)"
  },
  {
    "name": "America/Vancouver",
    "countryCode": "CA",
    "abbreviation": "PST",
    "offsetMinutes": -28800,
    "isDst": false,
    "timestamp": 16719987600,
    "region": "America",
    "displayName": "Vancouver (America -480)"
  },
  {
    "name": "Pacific/Pitcairn",
    "countryCode": "PN",
    "abbreviation": "PST",
    "offsetMinutes": -28800,
    "isDst": false,
    "timestamp": 893665800,
    "region": "Pacific",
    "displayName": "Pitcairn (Pacific -480)"
  },
  {
    "name": "America/Boise",
    "countryCode": "US",
    "abbreviation": "MST",
    "offsetMinutes": -25200,
    "isDst": false,
    "timestamp": 16719984000,
    "region": "America",
    "displayName": "Boise (America -420)"
  },
  {
    "name": "America/Cambridge_Bay",
    "countryCode": "CA",
    "abbreviation": "MST",
    "offsetMinutes": -25200,
    "isDst": false,
    "timestamp": 16719984000,
    "region": "America",
    "displayName": "Cambridge Bay (America -420)"
  },
  {
    "name": "America/Ciudad_Juarez",
    "countryCode": "MX",
    "abbreviation": "MST",
    "offsetMinutes": -25200,
    "isDst": false,
    "timestamp": 16719984000,
    "region": "America",
    "displayName": "Ciudad Juarez (America -420)"
  },
  {
    "name": "America/Creston",
    "countryCode": "CA",
    "abbreviation": "MST",
    "offsetMinutes": -25200,
    "isDst": false,
    "timestamp": -1627833600,
    "region": "America",
    "displayName": "Creston (America -420)"
  },
  {
    "name": "America/Dawson",
    "countryCode": "CA",
    "abbreviation": "MST",
    "offsetMinutes": -25200,
    "isDst": false,
    "timestamp": 1604214000,
    "region": "America",
    "displayName": "Dawson (America -420)"
  },
  {
    "name": "America/Dawson_Creek",
    "countryCode": "CA",
    "abbreviation": "MST",
    "offsetMinutes": -25200,
    "isDst": false,
    "timestamp": 84013200,
    "region": "America",
    "displayName": "Dawson Creek (America -420)"
  },
  {
    "name": "America/Denver",
    "countryCode": "US",
    "abbreviation": "MST",
    "offsetMinutes": -25200,
    "isDst": false,
    "timestamp": 16719984000,
    "region": "America",
    "displayName": "Denver (America -420)"
  },
  {
    "name": "America/Edmonton",
    "countryCode": "CA",
    "abbreviation": "MST",
    "offsetMinutes": -25200,
    "isDst": false,
    "timestamp": 16719984000,
    "region": "America",
    "displayName": "Edmonton (America -420)"
  },
  {
    "name": "America/Fort_Nelson",
    "countryCode": "CA",
    "abbreviation": "MST",
    "offsetMinutes": -25200,
    "isDst": false,
    "timestamp": 1425808800,
    "region": "America",
    "displayName": "Fort Nelson (America -420)"
  },
  {
    "name": "America/Hermosillo",
    "countryCode": "MX",
    "abbreviation": "MST",
    "offsetMinutes": -25200,
    "isDst": false,
    "timestamp": 909302400,
    "region": "America",
    "displayName": "Hermosillo (America -420)"
  },
  {
    "name": "America/Inuvik",
    "countryCode": "CA",
    "abbreviation": "MST",
    "offsetMinutes": -25200,
    "isDst": false,
    "timestamp": 16719984000,
    "region": "America",
    "displayName": "Inuvik (America -420)"
  },
  {
    "name": "America/Mazatlan",
    "countryCode": "MX",
    "abbreviation": "MST",
    "offsetMinutes": -25200,
    "isDst": false,
    "timestamp": 1667116800,
    "region": "America",
    "displayName": "Mazatlan (America -420)"
  },
  {
    "name": "America/Phoenix",
    "countryCode": "US",
    "abbreviation": "MST",
    "offsetMinutes": -25200,
    "isDst": false,
    "timestamp": -68659200,
    "region": "America",
    "displayName": "Phoenix (America -420)"
  },
  {
    "name": "America/Whitehorse",
    "countryCode": "CA",
    "abbreviation": "MST",
    "offsetMinutes": -25200,
    "isDst": false,
    "timestamp": 1604214000,
    "region": "America",
    "displayName": "Whitehorse (America -420)"
  },
  {
    "name": "America/Bahia_Banderas",
    "countryCode": "MX",
    "abbreviation": "CST",
    "offsetMinutes": -21600,
    "isDst": false,
    "timestamp": 1667113200,
    "region": "America",
    "displayName": "Bahia Banderas (America -360)"
  },
  {
    "name": "America/Belize",
    "countryCode": "BZ",
    "abbreviation": "CST",
    "offsetMinutes": -21600,
    "isDst": false,
    "timestamp": 413874000,
    "region": "America",
    "displayName": "Belize (America -360)"
  },
  {
    "name": "America/Chicago",
    "countryCode": "US",
    "abbreviation": "CST",
    "offsetMinutes": -21600,
    "isDst": false,
    "timestamp": 16719980400,
    "region": "America",
    "displayName": "Chicago (America -360)"
  },
  {
    "name": "America/Chihuahua",
    "countryCode": "MX",
    "abbreviation": "CST",
    "offsetMinutes": -21600,
    "isDst": false,
    "timestamp": 1667116800,
    "region": "America",
    "displayName": "Chihuahua (America -360)"
  },
  {
    "name": "America/Costa_Rica",
    "countryCode": "CR",
    "abbreviation": "CST",
    "offsetMinutes": -21600,
    "isDst": false,
    "timestamp": 700635600,
    "region": "America",
    "displayName": "Costa Rica (America -360)"
  },
  {
    "name": "America/El_Salvador",
    "countryCode": "SV",
    "abbreviation": "CST",
    "offsetMinutes": -21600,
    "isDst": false,
    "timestamp": 591166800,
    "region": "America",
    "displayName": "El Salvador (America -360)"
  },
  {
    "name": "America/Guatemala",
    "countryCode": "GT",
    "abbreviation": "CST",
    "offsetMinutes": -21600,
    "isDst": false,
    "timestamp": 1159678800,
    "region": "America",
    "displayName": "Guatemala (America -360)"
  },
  {
    "name": "America/Indiana/Knox",
    "countryCode": "US",
    "abbreviation": "CST",
    "offsetMinutes": -21600,
    "isDst": false,
    "timestamp": 16719980400,
    "region": "America",
    "displayName": "Indiana/Knox (America -360)"
  },
  {
    "name": "America/Indiana/Tell_City",
    "countryCode": "US",
    "abbreviation": "CST",
    "offsetMinutes": -21600,
    "isDst": false,
    "timestamp": 16719980400,
    "region": "America",
    "displayName": "Indiana/Tell City (America -360)"
  },
  {
    "name": "America/Managua",
    "countryCode": "NI",
    "abbreviation": "CST",
    "offsetMinutes": -21600,
    "isDst": false,
    "timestamp": 1159682400,
    "region": "America",
    "displayName": "Managua (America -360)"
  },
  {
    "name": "America/Matamoros",
    "countryCode": "MX",
    "abbreviation": "CST",
    "offsetMinutes": -21600,
    "isDst": false,
    "timestamp": 16719980400,
    "region": "America",
    "displayName": "Matamoros (America -360)"
  },
  {
    "name": "America/Menominee",
    "countryCode": "US",
    "abbreviation": "CST",
    "offsetMinutes": -21600,
    "isDst": false,
    "timestamp": 16719980400,
    "region": "America",
    "displayName": "Menominee (America -360)"
  },
  {
    "name": "America/Merida",
    "countryCode": "MX",
    "abbreviation": "CST",
    "offsetMinutes": -21600,
    "isDst": false,
    "timestamp": 1667113200,
    "region": "America",
    "displayName": "Merida (America -360)"
  },
  {
    "name": "America/Mexico_City",
    "countryCode": "MX",
    "abbreviation": "CST",
    "offsetMinutes": -21600,
    "isDst": false,
    "timestamp": 1667113200,
    "region": "America",
    "displayName": "Mexico City (America -360)"
  },
  {
    "name": "America/Monterrey",
    "countryCode": "MX",
    "abbreviation": "CST",
    "offsetMinutes": -21600,
    "isDst": false,
    "timestamp": 1667113200,
    "region": "America",
    "displayName": "Monterrey (America -360)"
  },
  {
    "name": "America/North_Dakota/Beulah",
    "countryCode": "US",
    "abbreviation": "CST",
    "offsetMinutes": -21600,
    "isDst": false,
    "timestamp": 16719980400,
    "region": "America",
    "displayName": "North Dakota/Beulah (America -360)"
  },
  {
    "name": "America/North_Dakota/Center",
    "countryCode": "US",
    "abbreviation": "CST",
    "offsetMinutes": -21600,
    "isDst": false,
    "timestamp": 16719980400,
    "region": "America",
    "displayName": "North Dakota/Center (America -360)"
  },
  {
    "name": "America/North_Dakota/New_Salem",
    "countryCode": "US",
    "abbreviation": "CST",
    "offsetMinutes": -21600,
    "isDst": false,
    "timestamp": 16719980400,
    "region": "America",
    "displayName": "North Dakota/New Salem (America -360)"
  },
  {
    "name": "America/Ojinaga",
    "countryCode": "MX",
    "abbreviation": "CST",
    "offsetMinutes": -21600,
    "isDst": false,
    "timestamp": 16719980400,
    "region": "America",
    "displayName": "Ojinaga (America -360)"
  },
  {
    "name": "America/Rankin_Inlet",
    "countryCode": "CA",
    "abbreviation": "CST",
    "offsetMinutes": -21600,
    "isDst": false,
    "timestamp": 16719980400,
    "region": "America",
    "displayName": "Rankin Inlet (America -360)"
  },
  {
    "name": "America/Regina",
    "countryCode": "CA",
    "abbreviation": "CST",
    "offsetMinutes": -21600,
    "isDst": false,
    "timestamp": -305737200,
    "region": "America",
    "displayName": "Regina (America -360)"
  },
  {
    "name": "America/Resolute",
    "countryCode": "CA",
    "abbreviation": "CST",
    "offsetMinutes": -21600,
    "isDst": false,
    "timestamp": 16719980400,
    "region": "America",
    "displayName": "Resolute (America -360)"
  },
  {
    "name": "America/Swift_Current",
    "countryCode": "CA",
    "abbreviation": "CST",
    "offsetMinutes": -21600,
    "isDst": false,
    "timestamp": 73472400,
    "region": "America",
    "displayName": "Swift Current (America -360)"
  },
  {
    "name": "America/Tegucigalpa",
    "countryCode": "HN",
    "abbreviation": "CST",
    "offsetMinutes": -21600,
    "isDst": false,
    "timestamp": 1154926800,
    "region": "America",
    "displayName": "Tegucigalpa (America -360)"
  },
  {
    "name": "America/Winnipeg",
    "countryCode": "CA",
    "abbreviation": "CST",
    "offsetMinutes": -21600,
    "isDst": false,
    "timestamp": 16719980400,
    "region": "America",
    "displayName": "Winnipeg (America -360)"
  },
  {
    "name": "Pacific/Galapagos",
    "countryCode": "EC",
    "abbreviation": "GALT",
    "offsetMinutes": -21600,
    "isDst": false,
    "timestamp": 728888400,
    "region": "Pacific",
    "displayName": "Galapagos (Pacific -360)"
  },
  {
    "name": "America/Atikokan",
    "countryCode": "CA",
    "abbreviation": "EST",
    "offsetMinutes": -18000,
    "isDst": false,
    "timestamp": -765392400,
    "region": "America",
    "displayName": "Atikokan (America -300)"
  },
  {
    "name": "America/Bogota",
    "countryCode": "CO",
    "abbreviation": "COT",
    "offsetMinutes": -18000,
    "isDst": false,
    "timestamp": 729057600,
    "region": "America",
    "displayName": "Bogota (America -300)"
  },
  {
    "name": "America/Cancun",
    "countryCode": "MX",
    "abbreviation": "EST",
    "offsetMinutes": -18000,
    "isDst": false,
    "timestamp": 1422777600,
    "region": "America",
    "displayName": "Cancun (America -300)"
  },
  {
    "name": "America/Cayman",
    "countryCode": "KY",
    "abbreviation": "EST",
    "offsetMinutes": -18000,
    "isDst": false,
    "timestamp": -1827687170,
    "region": "America",
    "displayName": "Cayman (America -300)"
  },
  {
    "name": "America/Detroit",
    "countryCode": "US",
    "abbreviation": "EST",
    "offsetMinutes": -18000,
    "isDst": false,
    "timestamp": 16719976800,
    "region": "America",
    "displayName": "Detroit (America -300)"
  },
  {
    "name": "America/Eirunepe",
    "countryCode": "BR",
    "abbreviation": "ACT",
    "offsetMinutes": -18000,
    "isDst": false,
    "timestamp": 1384056000,
    "region": "America",
    "displayName": "Eirunepe (America -300)"
  },
  {
    "name": "America/Grand_Turk",
    "countryCode": "TC",
    "abbreviation": "EST",
    "offsetMinutes": -18000,
    "isDst": false,
    "timestamp": 16719976800,
    "region": "America",
    "displayName": "Grand Turk (America -300)"
  },
  {
    "name": "America/Guayaquil",
    "countryCode": "EC",
    "abbreviation": "ECT",
    "offsetMinutes": -18000,
    "isDst": false,
    "timestamp": 728884800,
    "region": "America",
    "displayName": "Guayaquil (America -300)"
  },
  {
    "name": "America/Havana",
    "countryCode": "CU",
    "abbreviation": "CST",
    "offsetMinutes": -18000,
    "isDst": false,
    "timestamp": 16719973200,
    "region": "America",
    "displayName": "Havana (America -300)"
  },
  {
    "name": "America/Indiana/Indianapolis",
    "countryCode": "US",
    "abbreviation": "EST",
    "offsetMinutes": -18000,
    "isDst": false,
    "timestamp": 16719976800,
    "region": "America",
    "displayName": "Indiana/Indianapolis (America -300)"
  },
  {
    "name": "America/Indiana/Marengo",
    "countryCode": "US",
    "abbreviation": "EST",
    "offsetMinutes": -18000,
    "isDst": false,
    "timestamp": 16719976800,
    "region": "America",
    "displayName": "Indiana/Marengo (America -300)"
  },
  {
    "name": "America/Indiana/Petersburg",
    "countryCode": "US",
    "abbreviation": "EST",
    "offsetMinutes": -18000,
    "isDst": false,
    "timestamp": 16719976800,
    "region": "America",
    "displayName": "Indiana/Petersburg (America -300)"
  },
  {
    "name": "America/Indiana/Vevay",
    "countryCode": "US",
    "abbreviation": "EST",
    "offsetMinutes": -18000,
    "isDst": false,
    "timestamp": 16719976800,
    "region": "America",
    "displayName": "Indiana/Vevay (America -300)"
  },
  {
    "name": "America/Indiana/Vincennes",
    "countryCode": "US",
    "abbreviation": "EST",
    "offsetMinutes": -18000,
    "isDst": false,
    "timestamp": 16719976800,
    "region": "America",
    "displayName": "Indiana/Vincennes (America -300)"
  },
  {
    "name": "America/Indiana/Winamac",
    "countryCode": "US",
    "abbreviation": "EST",
    "offsetMinutes": -18000,
    "isDst": false,
    "timestamp": 16719976800,
    "region": "America",
    "displayName": "Indiana/Winamac (America -300)"
  },
  {
    "name": "America/Iqaluit",
    "countryCode": "CA",
    "abbreviation": "EST",
    "offsetMinutes": -18000,
    "isDst": false,
    "timestamp": 16719976800,
    "region": "America",
    "displayName": "Iqaluit (America -300)"
  },
  {
    "name": "America/Jamaica",
    "countryCode": "JM",
    "abbreviation": "EST",
    "offsetMinutes": -18000,
    "isDst": false,
    "timestamp": 436341600,
    "region": "America",
    "displayName": "Jamaica (America -300)"
  },
  {
    "name": "America/Kentucky/Louisville",
    "countryCode": "US",
    "abbreviation": "EST",
    "offsetMinutes": -18000,
    "isDst": false,
    "timestamp": 16719976800,
    "region": "America",
    "displayName": "Kentucky/Louisville (America -300)"
  },
  {
    "name": "America/Kentucky/Monticello",
    "countryCode": "US",
    "abbreviation": "EST",
    "offsetMinutes": -18000,
    "isDst": false,
    "timestamp": 16719976800,
    "region": "America",
    "displayName": "Kentucky/Monticello (America -300)"
  },
  {
    "name": "America/Lima",
    "countryCode": "PE",
    "abbreviation": "PET",
    "offsetMinutes": -18000,
    "isDst": false,
    "timestamp": 765172800,
    "region": "America",
    "displayName": "Lima (America -300)"
  },
  {
    "name": "America/Nassau",
    "countryCode": "BS",
    "abbreviation": "EST",
    "offsetMinutes": -18000,
    "isDst": false,
    "timestamp": 16719976800,
    "region": "America",
    "displayName": "Nassau (America -300)"
  },
  {
    "name": "America/New_York",
    "countryCode": "US",
    "abbreviation": "EST",
    "offsetMinutes": -18000,
    "isDst": false,
    "timestamp": 16719976800,
    "region": "America",
    "displayName": "New York (America -300)"
  },
  {
    "name": "America/Panama",
    "countryCode": "PA",
    "abbreviation": "EST",
    "offsetMinutes": -18000,
    "isDst": false,
    "timestamp": -1946918424,
    "region": "America",
    "displayName": "Panama (America -300)"
  },
  {
    "name": "America/Port-au-Prince",
    "countryCode": "HT",
    "abbreviation": "EST",
    "offsetMinutes": -18000,
    "isDst": false,
    "timestamp": 16719976800,
    "region": "America",
    "displayName": "Port-au-Prince (America -300)"
  },
  {
    "name": "America/Rio_Branco",
    "countryCode": "BR",
    "abbreviation": "ACT",
    "offsetMinutes": -18000,
    "isDst": false,
    "timestamp": 1384056000,
    "region": "America",
    "displayName": "Rio Branco (America -300)"
  },
  {
    "name": "America/Toronto",
    "countryCode": "CA",
    "abbreviation": "EST",
    "offsetMinutes": -18000,
    "isDst": false,
    "timestamp": 16719976800,
    "region": "America",
    "displayName": "Toronto (America -300)"
  },
  {
    "name": "Pacific/Easter",
    "countryCode": "CL",
    "abbreviation": "EASST",
    "offsetMinutes": -18000,
    "isDst": false,
    "timestamp": 16715131200,
    "region": "Pacific",
    "displayName": "Easter (Pacific -300)"
  },
  {
    "name": "America/Anguilla",
    "countryCode": "AI",
    "abbreviation": "AST",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": -1825098464,
    "region": "America",
    "displayName": "Anguilla (America -240)"
  },
  {
    "name": "America/Antigua",
    "countryCode": "AG",
    "abbreviation": "AST",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": -599598000,
    "region": "America",
    "displayName": "Antigua (America -240)"
  },
  {
    "name": "America/Aruba",
    "countryCode": "AW",
    "abbreviation": "AST",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": -157750200,
    "region": "America",
    "displayName": "Aruba (America -240)"
  },
  {
    "name": "America/Barbados",
    "countryCode": "BB",
    "abbreviation": "AST",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": 338706000,
    "region": "America",
    "displayName": "Barbados (America -240)"
  },
  {
    "name": "America/Blanc-Sablon",
    "countryCode": "CA",
    "abbreviation": "AST",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": -765399600,
    "region": "America",
    "displayName": "Blanc-Sablon (America -240)"
  },
  {
    "name": "America/Boa_Vista",
    "countryCode": "BR",
    "abbreviation": "AMT",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": 971578800,
    "region": "America",
    "displayName": "Boa Vista (America -240)"
  },
  {
    "name": "America/Campo_Grande",
    "countryCode": "BR",
    "abbreviation": "AMT",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": 1550372400,
    "region": "America",
    "displayName": "Campo Grande (America -240)"
  },
  {
    "name": "America/Caracas",
    "countryCode": "VE",
    "abbreviation": "VET",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": 1462086000,
    "region": "America",
    "displayName": "Caracas (America -240)"
  },
  {
    "name": "America/Cuiaba",
    "countryCode": "BR",
    "abbreviation": "AMT",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": 1550372400,
    "region": "America",
    "displayName": "Cuiaba (America -240)"
  },
  {
    "name": "America/Curacao",
    "countryCode": "CW",
    "abbreviation": "AST",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": -157750200,
    "region": "America",
    "displayName": "Curacao (America -240)"
  },
  {
    "name": "America/Dominica",
    "countryCode": "DM",
    "abbreviation": "AST",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": -1846266804,
    "region": "America",
    "displayName": "Dominica (America -240)"
  },
  {
    "name": "America/Glace_Bay",
    "countryCode": "CA",
    "abbreviation": "AST",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": 16719973200,
    "region": "America",
    "displayName": "Glace Bay (America -240)"
  },
  {
    "name": "America/Goose_Bay",
    "countryCode": "CA",
    "abbreviation": "AST",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": 16719973200,
    "region": "America",
    "displayName": "Goose Bay (America -240)"
  },
  {
    "name": "America/Grenada",
    "countryCode": "GD",
    "abbreviation": "AST",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": -1846266780,
    "region": "America",
    "displayName": "Grenada (America -240)"
  },
  {
    "name": "America/Guadeloupe",
    "countryCode": "GP",
    "abbreviation": "AST",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": -1848254032,
    "region": "America",
    "displayName": "Guadeloupe (America -240)"
  },
  {
    "name": "America/Guyana",
    "countryCode": "GY",
    "abbreviation": "GYT",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": 701841600,
    "region": "America",
    "displayName": "Guyana (America -240)"
  },
  {
    "name": "America/Halifax",
    "countryCode": "CA",
    "abbreviation": "AST",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": 16719973200,
    "region": "America",
    "displayName": "Halifax (America -240)"
  },
  {
    "name": "America/Kralendijk",
    "countryCode": "BQ",
    "abbreviation": "AST",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": -765399600,
    "region": "America",
    "displayName": "Kralendijk (America -240)"
  },
  {
    "name": "America/La_Paz",
    "countryCode": "BO",
    "abbreviation": "BOT",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": -1192307244,
    "region": "America",
    "displayName": "La Paz (America -240)"
  },
  {
    "name": "America/Lower_Princes",
    "countryCode": "SX",
    "abbreviation": "AST",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": -765399600,
    "region": "America",
    "displayName": "Lower Princes (America -240)"
  },
  {
    "name": "America/Manaus",
    "countryCode": "BR",
    "abbreviation": "AMT",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": 761713200,
    "region": "America",
    "displayName": "Manaus (America -240)"
  },
  {
    "name": "America/Marigot",
    "countryCode": "MF",
    "abbreviation": "AST",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": -765399600,
    "region": "America",
    "displayName": "Marigot (America -240)"
  },
  {
    "name": "America/Martinique",
    "countryCode": "MQ",
    "abbreviation": "AST",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": 338958000,
    "region": "America",
    "displayName": "Martinique (America -240)"
  },
  {
    "name": "America/Moncton",
    "countryCode": "CA",
    "abbreviation": "AST",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": 16719973200,
    "region": "America",
    "displayName": "Moncton (America -240)"
  },
  {
    "name": "America/Montserrat",
    "countryCode": "MS",
    "abbreviation": "AST",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": -1846266608,
    "region": "America",
    "displayName": "Montserrat (America -240)"
  },
  {
    "name": "America/Port_of_Spain",
    "countryCode": "TT",
    "abbreviation": "AST",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": -1825098836,
    "region": "America",
    "displayName": "Port of Spain (America -240)"
  },
  {
    "name": "America/Porto_Velho",
    "countryCode": "BR",
    "abbreviation": "AMT",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": 571201200,
    "region": "America",
    "displayName": "Porto Velho (America -240)"
  },
  {
    "name": "America/Puerto_Rico",
    "countryCode": "PR",
    "abbreviation": "AST",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": -765399600,
    "region": "America",
    "displayName": "Puerto Rico (America -240)"
  },
  {
    "name": "America/Santo_Domingo",
    "countryCode": "DO",
    "abbreviation": "AST",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": 975823200,
    "region": "America",
    "displayName": "Santo Domingo (America -240)"
  },
  {
    "name": "America/St_Barthelemy",
    "countryCode": "BL",
    "abbreviation": "AST",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": -765399600,
    "region": "America",
    "displayName": "St Barthelemy (America -240)"
  },
  {
    "name": "America/St_Kitts",
    "countryCode": "KN",
    "abbreviation": "AST",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": -1825098548,
    "region": "America",
    "displayName": "St Kitts (America -240)"
  },
  {
    "name": "America/St_Lucia",
    "countryCode": "LC",
    "abbreviation": "AST",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": -1830369360,
    "region": "America",
    "displayName": "St Lucia (America -240)"
  },
  {
    "name": "America/St_Thomas",
    "countryCode": "VI",
    "abbreviation": "AST",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": -1846266016,
    "region": "America",
    "displayName": "St Thomas (America -240)"
  },
  {
    "name": "America/St_Vincent",
    "countryCode": "VC",
    "abbreviation": "AST",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": -1830369304,
    "region": "America",
    "displayName": "St Vincent (America -240)"
  },
  {
    "name": "America/Thule",
    "countryCode": "GL",
    "abbreviation": "AST",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": 16719973200,
    "region": "America",
    "displayName": "Thule (America -240)"
  },
  {
    "name": "America/Tortola",
    "countryCode": "VG",
    "abbreviation": "AST",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": -1846266092,
    "region": "America",
    "displayName": "Tortola (America -240)"
  },
  {
    "name": "Atlantic/Bermuda",
    "countryCode": "BM",
    "abbreviation": "AST",
    "offsetMinutes": -14400,
    "isDst": false,
    "timestamp": 16719973200,
    "region": "Atlantic",
    "displayName": "Bermuda (Atlantic -240)"
  },
  {
    "name": "America/St_Johns",
    "countryCode": "CA",
    "abbreviation": "NST",
    "offsetMinutes": -12600,
    "isDst": false,
    "timestamp": 16719971400,
    "region": "America",
    "displayName": "St Johns (America -210)"
  },
  {
    "name": "America/Araguaina",
    "countryCode": "BR",
    "abbreviation": "BRT",
    "offsetMinutes": -10800,
    "isDst": false,
    "timestamp": 1361066400,
    "region": "America",
    "displayName": "Araguaina (America -180)"
  },
  {
    "name": "America/Argentina/Buenos_Aires",
    "countryCode": "AR",
    "abbreviation": "ART",
    "offsetMinutes": -10800,
    "isDst": false,
    "timestamp": 1237082400,
    "region": "America",
    "displayName": "Argentina/Buenos Aires (America -180)"
  },
  {
    "name": "America/Argentina/Catamarca",
    "countryCode": "AR",
    "abbreviation": "ART",
    "offsetMinutes": -10800,
    "isDst": false,
    "timestamp": 1205632800,
    "region": "America",
    "displayName": "Argentina/Catamarca (America -180)"
  },
  {
    "name": "America/Argentina/Cordoba",
    "countryCode": "AR",
    "abbreviation": "ART",
    "offsetMinutes": -10800,
    "isDst": false,
    "timestamp": 1237082400,
    "region": "America",
    "displayName": "Argentina/Cordoba (America -180)"
  },
  {
    "name": "America/Argentina/Jujuy",
    "countryCode": "AR",
    "abbreviation": "ART",
    "offsetMinutes": -10800,
    "isDst": false,
    "timestamp": 1205632800,
    "region": "America",
    "displayName": "Argentina/Jujuy (America -180)"
  },
  {
    "name": "America/Argentina/La_Rioja",
    "countryCode": "AR",
    "abbreviation": "ART",
    "offsetMinutes": -10800,
    "isDst": false,
    "timestamp": 1205632800,
    "region": "America",
    "displayName": "Argentina/La Rioja (America -180)"
  },
  {
    "name": "America/Argentina/Mendoza",
    "countryCode": "AR",
    "abbreviation": "ART",
    "offsetMinutes": -10800,
    "isDst": false,
    "timestamp": 1205632800,
    "region": "America",
    "displayName": "Argentina/Mendoza (America -180)"
  },
  {
    "name": "America/Argentina/Rio_Gallegos",
    "countryCode": "AR",
    "abbreviation": "ART",
    "offsetMinutes": -10800,
    "isDst": false,
    "timestamp": 1205632800,
    "region": "America",
    "displayName": "Argentina/Rio Gallegos (America -180)"
  },
  {
    "name": "America/Argentina/Salta",
    "countryCode": "AR",
    "abbreviation": "ART",
    "offsetMinutes": -10800,
    "isDst": false,
    "timestamp": 1205632800,
    "region": "America",
    "displayName": "Argentina/Salta (America -180)"
  },
  {
    "name": "America/Argentina/San_Juan",
    "countryCode": "AR",
    "abbreviation": "ART",
    "offsetMinutes": -10800,
    "isDst": false,
    "timestamp": 1205632800,
    "region": "America",
    "displayName": "Argentina/San Juan (America -180)"
  },
  {
    "name": "America/Argentina/San_Luis",
    "countryCode": "AR",
    "abbreviation": "ART",
    "offsetMinutes": -10800,
    "isDst": false,
    "timestamp": 1255233600,
    "region": "America",
    "displayName": "Argentina/San Luis (America -180)"
  },
  {
    "name": "America/Argentina/Tucuman",
    "countryCode": "AR",
    "abbreviation": "ART",
    "offsetMinutes": -10800,
    "isDst": false,
    "timestamp": 1237082400,
    "region": "America",
    "displayName": "Argentina/Tucuman (America -180)"
  },
  {
    "name": "America/Argentina/Ushuaia",
    "countryCode": "AR",
    "abbreviation": "ART",
    "offsetMinutes": -10800,
    "isDst": false,
    "timestamp": 1205632800,
    "region": "America",
    "displayName": "Argentina/Ushuaia (America -180)"
  },
  {
    "name": "America/Asuncion",
    "countryCode": "PY",
    "abbreviation": "PYT",
    "offsetMinutes": -10800,
    "isDst": false,
    "timestamp": 1728961200,
    "region": "America",
    "displayName": "Asuncion (America -180)"
  },
  {
    "name": "America/Bahia",
    "countryCode": "BR",
    "abbreviation": "BRT",
    "offsetMinutes": -10800,
    "isDst": false,
    "timestamp": 1330221600,
    "region": "America",
    "displayName": "Bahia (America -180)"
  },
  {
    "name": "America/Belem",
    "countryCode": "BR",
    "abbreviation": "BRT",
    "offsetMinutes": -10800,
    "isDst": false,
    "timestamp": 571197600,
    "region": "America",
    "displayName": "Belem (America -180)"
  },
  {
    "name": "America/Cayenne",
    "countryCode": "GF",
    "abbreviation": "GFT",
    "offsetMinutes": -10800,
    "isDst": false,
    "timestamp": -71092800,
    "region": "America",
    "displayName": "Cayenne (America -180)"
  },
  {
    "name": "America/Coyhaique",
    "countryCode": "CL",
    "abbreviation": "CLST",
    "offsetMinutes": -10800,
    "isDst": false,
    "timestamp": 1742439600,
    "region": "America",
    "displayName": "Coyhaique (America -180)"
  },
  {
    "name": "America/Fortaleza",
    "countryCode": "BR",
    "abbreviation": "BRT",
    "offsetMinutes": -10800,
    "isDst": false,
    "timestamp": 1013911200,
    "region": "America",
    "displayName": "Fortaleza (America -180)"
  },
  {
    "name": "America/Maceio",
    "countryCode": "BR",
    "abbreviation": "BRT",
    "offsetMinutes": -10800,
    "isDst": false,
    "timestamp": 1013911200,
    "region": "America",
    "displayName": "Maceio (America -180)"
  },
  {
    "name": "America/Miquelon",
    "countryCode": "PM",
    "abbreviation": "PMST",
    "offsetMinutes": -10800,
    "isDst": false,
    "timestamp": 16719969600,
    "region": "America",
    "displayName": "Miquelon (America -180)"
  },
  {
    "name": "America/Montevideo",
    "countryCode": "UY",
    "abbreviation": "UYT",
    "offsetMinutes": -10800,
    "isDst": false,
    "timestamp": 1425787200,
    "region": "America",
    "displayName": "Montevideo (America -180)"
  },
  {
    "name": "America/Paramaribo",
    "countryCode": "SR",
    "abbreviation": "SRT",
    "offsetMinutes": -10800,
    "isDst": false,
    "timestamp": 465449400,
    "region": "America",
    "displayName": "Paramaribo (America -180)"
  },
  {
    "name": "America/Punta_Arenas",
    "countryCode": "CL",
    "abbreviation": "CLST",
    "offsetMinutes": -10800,
    "isDst": false,
    "timestamp": 1471147200,
    "region": "America",
    "displayName": "Punta Arenas (America -180)"
  },
  {
    "name": "America/Recife",
    "countryCode": "BR",
    "abbreviation": "BRT",
    "offsetMinutes": -10800,
    "isDst": false,
    "timestamp": 1013911200,
    "region": "America",
    "displayName": "Recife (America -180)"
  },
  {
    "name": "America/Santarem",
    "countryCode": "BR",
    "abbreviation": "BRT",
    "offsetMinutes": -10800,
    "isDst": false,
    "timestamp": 1214280000,
    "region": "America",
    "displayName": "Santarem (America -180)"
  },
  {
    "name": "America/Santiago",
    "countryCode": "CL",
    "abbreviation": "CLST",
    "offsetMinutes": -10800,
    "isDst": false,
    "timestamp": 16715131200,
    "region": "America",
    "displayName": "Santiago (America -180)"
  },
  {
    "name": "America/Sao_Paulo",
    "countryCode": "BR",
    "abbreviation": "BRT",
    "offsetMinutes": -10800,
    "isDst": false,
    "timestamp": 1550368800,
    "region": "America",
    "displayName": "Sao Paulo (America -180)"
  },
  {
    "name": "Antarctica/Palmer",
    "countryCode": "AQ",
    "abbreviation": "CLST",
    "offsetMinutes": -10800,
    "isDst": false,
    "timestamp": 1471147200,
    "region": "Antarctica",
    "displayName": "Palmer (Antarctica -180)"
  },
  {
    "name": "Antarctica/Rothera",
    "countryCode": "AQ",
    "abbreviation": "ART",
    "offsetMinutes": -10800,
    "isDst": false,
    "timestamp": 218246400,
    "region": "Antarctica",
    "displayName": "Rothera (Antarctica -180)"
  },
  {
    "name": "Atlantic/Stanley",
    "countryCode": "FK",
    "abbreviation": "FKT",
    "offsetMinutes": -10800,
    "isDst": false,
    "timestamp": 1283666400,
    "region": "Atlantic",
    "displayName": "Stanley (Atlantic -180)"
  },
  {
    "name": "America/Noronha",
    "countryCode": "BR",
    "abbreviation": "FNT",
    "offsetMinutes": -7200,
    "isDst": false,
    "timestamp": 1013907600,
    "region": "America",
    "displayName": "Noronha (America -120)"
  },
  {
    "name": "America/Nuuk",
    "countryCode": "GL",
    "abbreviation": "WGT",
    "offsetMinutes": -7200,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "America",
    "displayName": "Nuuk (America -120)"
  },
  {
    "name": "America/Scoresbysund",
    "countryCode": "GL",
    "abbreviation": "WGT",
    "offsetMinutes": -7200,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "America",
    "displayName": "Scoresbysund (America -120)"
  },
  {
    "name": "Atlantic/South_Georgia",
    "countryCode": "GS",
    "abbreviation": "GST",
    "offsetMinutes": -7200,
    "isDst": false,
    "timestamp": -2524512832,
    "region": "Atlantic",
    "displayName": "South Georgia (Atlantic -120)"
  },
  {
    "name": "Atlantic/Azores",
    "countryCode": "PT",
    "abbreviation": "AZOT",
    "offsetMinutes": -3600,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Atlantic",
    "displayName": "Azores (Atlantic -60)"
  },
  {
    "name": "Atlantic/Cape_Verde",
    "countryCode": "CV",
    "abbreviation": "CVT",
    "offsetMinutes": -3600,
    "isDst": false,
    "timestamp": 186120000,
    "region": "Atlantic",
    "displayName": "Cape Verde (Atlantic -60)"
  },
  {
    "name": "Africa/Abidjan",
    "countryCode": "CI",
    "abbreviation": "GMT",
    "offsetMinutes": 0,
    "isDst": false,
    "timestamp": -1830383032,
    "region": "Africa",
    "displayName": "Abidjan (Africa +0)"
  },
  {
    "name": "Africa/Accra",
    "countryCode": "GH",
    "abbreviation": "GMT",
    "offsetMinutes": 0,
    "isDst": false,
    "timestamp": -441844200,
    "region": "Africa",
    "displayName": "Accra (Africa +0)"
  },
  {
    "name": "Africa/Bamako",
    "countryCode": "ML",
    "abbreviation": "GMT",
    "offsetMinutes": 0,
    "isDst": false,
    "timestamp": -300841200,
    "region": "Africa",
    "displayName": "Bamako (Africa +0)"
  },
  {
    "name": "Africa/Banjul",
    "countryCode": "GM",
    "abbreviation": "GMT",
    "offsetMinutes": 0,
    "isDst": false,
    "timestamp": -880930800,
    "region": "Africa",
    "displayName": "Banjul (Africa +0)"
  },
  {
    "name": "Africa/Bissau",
    "countryCode": "GW",
    "abbreviation": "GMT",
    "offsetMinutes": 0,
    "isDst": false,
    "timestamp": 157770000,
    "region": "Africa",
    "displayName": "Bissau (Africa +0)"
  },
  {
    "name": "Africa/Conakry",
    "countryCode": "GN",
    "abbreviation": "GMT",
    "offsetMinutes": 0,
    "isDst": false,
    "timestamp": -315615600,
    "region": "Africa",
    "displayName": "Conakry (Africa +0)"
  },
  {
    "name": "Africa/Dakar",
    "countryCode": "SN",
    "abbreviation": "GMT",
    "offsetMinutes": 0,
    "isDst": false,
    "timestamp": -902098800,
    "region": "Africa",
    "displayName": "Dakar (Africa +0)"
  },
  {
    "name": "Africa/Freetown",
    "countryCode": "SL",
    "abbreviation": "GMT",
    "offsetMinutes": 0,
    "isDst": false,
    "timestamp": -885769200,
    "region": "Africa",
    "displayName": "Freetown (Africa +0)"
  },
  {
    "name": "Africa/Lome",
    "countryCode": "TG",
    "abbreviation": "GMT",
    "offsetMinutes": 0,
    "isDst": false,
    "timestamp": -2429827492,
    "region": "Africa",
    "displayName": "Lome (Africa +0)"
  },
  {
    "name": "Africa/Monrovia",
    "countryCode": "LR",
    "abbreviation": "GMT",
    "offsetMinutes": 0,
    "isDst": false,
    "timestamp": 63593070,
    "region": "Africa",
    "displayName": "Monrovia (Africa +0)"
  },
  {
    "name": "Africa/Nouakchott",
    "countryCode": "MR",
    "abbreviation": "GMT",
    "offsetMinutes": 0,
    "isDst": false,
    "timestamp": -286930800,
    "region": "Africa",
    "displayName": "Nouakchott (Africa +0)"
  },
  {
    "name": "Africa/Ouagadougou",
    "countryCode": "BF",
    "abbreviation": "GMT",
    "offsetMinutes": 0,
    "isDst": false,
    "timestamp": -1830383636,
    "region": "Africa",
    "displayName": "Ouagadougou (Africa +0)"
  },
  {
    "name": "Africa/Sao_Tome",
    "countryCode": "ST",
    "abbreviation": "GMT",
    "offsetMinutes": 0,
    "isDst": false,
    "timestamp": 1546304400,
    "region": "Africa",
    "displayName": "Sao Tome (Africa +0)"
  },
  {
    "name": "America/Danmarkshavn",
    "countryCode": "GL",
    "abbreviation": "GMT",
    "offsetMinutes": 0,
    "isDst": false,
    "timestamp": 820465200,
    "region": "America",
    "displayName": "Danmarkshavn (America +0)"
  },
  {
    "name": "Antarctica/Troll",
    "countryCode": "AQ",
    "abbreviation": "GMT",
    "offsetMinutes": 0,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Antarctica",
    "displayName": "Troll (Antarctica +0)"
  },
  {
    "name": "Atlantic/Canary",
    "countryCode": "ES",
    "abbreviation": "WET",
    "offsetMinutes": 0,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Atlantic",
    "displayName": "Canary (Atlantic +0)"
  },
  {
    "name": "Atlantic/Faroe",
    "countryCode": "FO",
    "abbreviation": "WET",
    "offsetMinutes": 0,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Atlantic",
    "displayName": "Faroe (Atlantic +0)"
  },
  {
    "name": "Atlantic/Madeira",
    "countryCode": "PT",
    "abbreviation": "WET",
    "offsetMinutes": 0,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Atlantic",
    "displayName": "Madeira (Atlantic +0)"
  },
  {
    "name": "Atlantic/Reykjavik",
    "countryCode": "IS",
    "abbreviation": "GMT",
    "offsetMinutes": 0,
    "isDst": false,
    "timestamp": -54770400,
    "region": "Atlantic",
    "displayName": "Reykjavik (Atlantic +0)"
  },
  {
    "name": "Atlantic/St_Helena",
    "countryCode": "SH",
    "abbreviation": "GMT",
    "offsetMinutes": 0,
    "isDst": false,
    "timestamp": -599614632,
    "region": "Atlantic",
    "displayName": "St Helena (Atlantic +0)"
  },
  {
    "name": "Etc/UTC",
    "countryCode": "",
    "abbreviation": "GMT",
    "offsetMinutes": 0,
    "isDst": false,
    "timestamp": -2208988800,
    "region": "Etc",
    "displayName": "UTC (Etc +0)"
  },
  {
    "name": "Europe/Dublin",
    "countryCode": "IE",
    "abbreviation": "GMT",
    "offsetMinutes": 0,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Dublin (Europe +0)"
  },
  {
    "name": "Europe/Guernsey",
    "countryCode": "GG",
    "abbreviation": "GMT",
    "offsetMinutes": 0,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Guernsey (Europe +0)"
  },
  {
    "name": "Europe/Isle_of_Man",
    "countryCode": "IM",
    "abbreviation": "GMT",
    "offsetMinutes": 0,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Isle of Man (Europe +0)"
  },
  {
    "name": "Europe/Jersey",
    "countryCode": "JE",
    "abbreviation": "GMT",
    "offsetMinutes": 0,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Jersey (Europe +0)"
  },
  {
    "name": "Europe/Lisbon",
    "countryCode": "PT",
    "abbreviation": "WET",
    "offsetMinutes": 0,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Lisbon (Europe +0)"
  },
  {
    "name": "Europe/London",
    "countryCode": "GB",
    "abbreviation": "GMT",
    "offsetMinutes": 0,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "London (Europe +0)"
  },
  {
    "name": "Africa/Algiers",
    "countryCode": "DZ",
    "abbreviation": "CET",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 357523200,
    "region": "Africa",
    "displayName": "Algiers (Africa +60)"
  },
  {
    "name": "Africa/Bangui",
    "countryCode": "CF",
    "abbreviation": "WAT",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": -1830388460,
    "region": "Africa",
    "displayName": "Bangui (Africa +60)"
  },
  {
    "name": "Africa/Brazzaville",
    "countryCode": "CG",
    "abbreviation": "WAT",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": -1830387668,
    "region": "Africa",
    "displayName": "Brazzaville (Africa +60)"
  },
  {
    "name": "Africa/Casablanca",
    "countryCode": "MA",
    "abbreviation": "WEST",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 3703456800,
    "region": "Africa",
    "displayName": "Casablanca (Africa +60)"
  },
  {
    "name": "Africa/Ceuta",
    "countryCode": "ES",
    "abbreviation": "CET",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Africa",
    "displayName": "Ceuta (Africa +60)"
  },
  {
    "name": "Africa/Douala",
    "countryCode": "CM",
    "abbreviation": "WAT",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": -1830386328,
    "region": "Africa",
    "displayName": "Douala (Africa +60)"
  },
  {
    "name": "Africa/El_Aaiun",
    "countryCode": "MA",
    "abbreviation": "WEST",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 3703456800,
    "region": "Africa",
    "displayName": "El Aaiun (Africa +60)"
  },
  {
    "name": "Africa/Kinshasa",
    "countryCode": "CD",
    "abbreviation": "WAT",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": -2276643672,
    "region": "Africa",
    "displayName": "Kinshasa (Africa +60)"
  },
  {
    "name": "Africa/Lagos",
    "countryCode": "NG",
    "abbreviation": "WAT",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": -1588465800,
    "region": "Africa",
    "displayName": "Lagos (Africa +60)"
  },
  {
    "name": "Africa/Libreville",
    "countryCode": "GA",
    "abbreviation": "WAT",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": -1830386268,
    "region": "Africa",
    "displayName": "Libreville (Africa +60)"
  },
  {
    "name": "Africa/Luanda",
    "countryCode": "AO",
    "abbreviation": "WAT",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": -1830387600,
    "region": "Africa",
    "displayName": "Luanda (Africa +60)"
  },
  {
    "name": "Africa/Malabo",
    "countryCode": "GQ",
    "abbreviation": "WAT",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": -190857600,
    "region": "Africa",
    "displayName": "Malabo (Africa +60)"
  },
  {
    "name": "Africa/Ndjamena",
    "countryCode": "TD",
    "abbreviation": "WAT",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 321314400,
    "region": "Africa",
    "displayName": "Ndjamena (Africa +60)"
  },
  {
    "name": "Africa/Niamey",
    "countryCode": "NE",
    "abbreviation": "WAT",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": -315619200,
    "region": "Africa",
    "displayName": "Niamey (Africa +60)"
  },
  {
    "name": "Africa/Porto-Novo",
    "countryCode": "BJ",
    "abbreviation": "WAT",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": -1131235200,
    "region": "Africa",
    "displayName": "Porto-Novo (Africa +60)"
  },
  {
    "name": "Africa/Tunis",
    "countryCode": "TN",
    "abbreviation": "CET",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 1224982800,
    "region": "Africa",
    "displayName": "Tunis (Africa +60)"
  },
  {
    "name": "Arctic/Longyearbyen",
    "countryCode": "SJ",
    "abbreviation": "CET",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Arctic",
    "displayName": "Longyearbyen (Arctic +60)"
  },
  {
    "name": "Europe/Amsterdam",
    "countryCode": "NL",
    "abbreviation": "CET",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Amsterdam (Europe +60)"
  },
  {
    "name": "Europe/Andorra",
    "countryCode": "AD",
    "abbreviation": "CET",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Andorra (Europe +60)"
  },
  {
    "name": "Europe/Belgrade",
    "countryCode": "RS",
    "abbreviation": "CET",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Belgrade (Europe +60)"
  },
  {
    "name": "Europe/Berlin",
    "countryCode": "DE",
    "abbreviation": "CET",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Berlin (Europe +60)"
  },
  {
    "name": "Europe/Bratislava",
    "countryCode": "SK",
    "abbreviation": "CET",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Bratislava (Europe +60)"
  },
  {
    "name": "Europe/Brussels",
    "countryCode": "BE",
    "abbreviation": "CET",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Brussels (Europe +60)"
  },
  {
    "name": "Europe/Budapest",
    "countryCode": "HU",
    "abbreviation": "CET",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Budapest (Europe +60)"
  },
  {
    "name": "Europe/Busingen",
    "countryCode": "DE",
    "abbreviation": "CET",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Busingen (Europe +60)"
  },
  {
    "name": "Europe/Copenhagen",
    "countryCode": "DK",
    "abbreviation": "CET",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Copenhagen (Europe +60)"
  },
  {
    "name": "Europe/Gibraltar",
    "countryCode": "GI",
    "abbreviation": "CET",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Gibraltar (Europe +60)"
  },
  {
    "name": "Europe/Ljubljana",
    "countryCode": "SI",
    "abbreviation": "CET",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Ljubljana (Europe +60)"
  },
  {
    "name": "Europe/Luxembourg",
    "countryCode": "LU",
    "abbreviation": "CET",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Luxembourg (Europe +60)"
  },
  {
    "name": "Europe/Madrid",
    "countryCode": "ES",
    "abbreviation": "CET",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Madrid (Europe +60)"
  },
  {
    "name": "Europe/Malta",
    "countryCode": "MT",
    "abbreviation": "CET",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Malta (Europe +60)"
  },
  {
    "name": "Europe/Monaco",
    "countryCode": "MC",
    "abbreviation": "CET",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Monaco (Europe +60)"
  },
  {
    "name": "Europe/Oslo",
    "countryCode": "NO",
    "abbreviation": "CET",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Oslo (Europe +60)"
  },
  {
    "name": "Europe/Paris",
    "countryCode": "FR",
    "abbreviation": "CET",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Paris (Europe +60)"
  },
  {
    "name": "Europe/Podgorica",
    "countryCode": "ME",
    "abbreviation": "CET",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Podgorica (Europe +60)"
  },
  {
    "name": "Europe/Prague",
    "countryCode": "CZ",
    "abbreviation": "CET",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Prague (Europe +60)"
  },
  {
    "name": "Europe/Rome",
    "countryCode": "IT",
    "abbreviation": "CET",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Rome (Europe +60)"
  },
  {
    "name": "Europe/San_Marino",
    "countryCode": "SM",
    "abbreviation": "CET",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "San Marino (Europe +60)"
  },
  {
    "name": "Europe/Sarajevo",
    "countryCode": "BA",
    "abbreviation": "CET",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Sarajevo (Europe +60)"
  },
  {
    "name": "Europe/Skopje",
    "countryCode": "MK",
    "abbreviation": "CET",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Skopje (Europe +60)"
  },
  {
    "name": "Europe/Stockholm",
    "countryCode": "SE",
    "abbreviation": "CET",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Stockholm (Europe +60)"
  },
  {
    "name": "Europe/Tirane",
    "countryCode": "AL",
    "abbreviation": "CET",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Tirane (Europe +60)"
  },
  {
    "name": "Europe/Vaduz",
    "countryCode": "LI",
    "abbreviation": "CET",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Vaduz (Europe +60)"
  },
  {
    "name": "Europe/Vatican",
    "countryCode": "VA",
    "abbreviation": "CET",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Vatican (Europe +60)"
  },
  {
    "name": "Europe/Vienna",
    "countryCode": "AT",
    "abbreviation": "CET",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Vienna (Europe +60)"
  },
  {
    "name": "Europe/Warsaw",
    "countryCode": "PL",
    "abbreviation": "CET",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Warsaw (Europe +60)"
  },
  {
    "name": "Europe/Zagreb",
    "countryCode": "HR",
    "abbreviation": "CET",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Zagreb (Europe +60)"
  },
  {
    "name": "Europe/Zurich",
    "countryCode": "CH",
    "abbreviation": "CET",
    "offsetMinutes": 3600,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Zurich (Europe +60)"
  },
  {
    "name": "Africa/Blantyre",
    "countryCode": "MW",
    "abbreviation": "CAT",
    "offsetMinutes": 7200,
    "isDst": false,
    "timestamp": -1404440460,
    "region": "Africa",
    "displayName": "Blantyre (Africa +120)"
  },
  {
    "name": "Africa/Bujumbura",
    "countryCode": "BI",
    "abbreviation": "CAT",
    "offsetMinutes": 7200,
    "isDst": false,
    "timestamp": -2524528648,
    "region": "Africa",
    "displayName": "Bujumbura (Africa +120)"
  },
  {
    "name": "Africa/Cairo",
    "countryCode": "EG",
    "abbreviation": "EET",
    "offsetMinutes": 7200,
    "isDst": false,
    "timestamp": 16719771600,
    "region": "Africa",
    "displayName": "Cairo (Africa +120)"
  },
  {
    "name": "Africa/Gaborone",
    "countryCode": "BW",
    "abbreviation": "CAT",
    "offsetMinutes": 7200,
    "isDst": false,
    "timestamp": -813805200,
    "region": "Africa",
    "displayName": "Gaborone (Africa +120)"
  },
  {
    "name": "Africa/Harare",
    "countryCode": "ZW",
    "abbreviation": "CAT",
    "offsetMinutes": 7200,
    "isDst": false,
    "timestamp": -2109290652,
    "region": "Africa",
    "displayName": "Harare (Africa +120)"
  },
  {
    "name": "Africa/Johannesburg",
    "countryCode": "ZA",
    "abbreviation": "SAST",
    "offsetMinutes": 7200,
    "isDst": false,
    "timestamp": -813805200,
    "region": "Africa",
    "displayName": "Johannesburg (Africa +120)"
  },
  {
    "name": "Africa/Juba",
    "countryCode": "SS",
    "abbreviation": "CAT",
    "offsetMinutes": 7200,
    "isDst": false,
    "timestamp": 1612126800,
    "region": "Africa",
    "displayName": "Juba (Africa +120)"
  },
  {
    "name": "Africa/Khartoum",
    "countryCode": "SD",
    "abbreviation": "CAT",
    "offsetMinutes": 7200,
    "isDst": false,
    "timestamp": 1509483600,
    "region": "Africa",
    "displayName": "Khartoum (Africa +120)"
  },
  {
    "name": "Africa/Kigali",
    "countryCode": "RW",
    "abbreviation": "CAT",
    "offsetMinutes": 7200,
    "isDst": false,
    "timestamp": -1091498416,
    "region": "Africa",
    "displayName": "Kigali (Africa +120)"
  },
  {
    "name": "Africa/Lubumbashi",
    "countryCode": "CD",
    "abbreviation": "CAT",
    "offsetMinutes": 7200,
    "isDst": false,
    "timestamp": -1567990800,
    "region": "Africa",
    "displayName": "Lubumbashi (Africa +120)"
  },
  {
    "name": "Africa/Lusaka",
    "countryCode": "ZM",
    "abbreviation": "CAT",
    "offsetMinutes": 7200,
    "isDst": false,
    "timestamp": -2109289988,
    "region": "Africa",
    "displayName": "Lusaka (Africa +120)"
  },
  {
    "name": "Africa/Maputo",
    "countryCode": "MZ",
    "abbreviation": "CAT",
    "offsetMinutes": 7200,
    "isDst": false,
    "timestamp": -1924999818,
    "region": "Africa",
    "displayName": "Maputo (Africa +120)"
  },
  {
    "name": "Africa/Maseru",
    "countryCode": "LS",
    "abbreviation": "SAST",
    "offsetMinutes": 7200,
    "isDst": false,
    "timestamp": -813805200,
    "region": "Africa",
    "displayName": "Maseru (Africa +120)"
  },
  {
    "name": "Africa/Mbabane",
    "countryCode": "SZ",
    "abbreviation": "SAST",
    "offsetMinutes": 7200,
    "isDst": false,
    "timestamp": -2109290664,
    "region": "Africa",
    "displayName": "Mbabane (Africa +120)"
  },
  {
    "name": "Africa/Tripoli",
    "countryCode": "LY",
    "abbreviation": "EET",
    "offsetMinutes": 7200,
    "isDst": false,
    "timestamp": 1382659200,
    "region": "Africa",
    "displayName": "Tripoli (Africa +120)"
  },
  {
    "name": "Africa/Windhoek",
    "countryCode": "NA",
    "abbreviation": "CAT",
    "offsetMinutes": 7200,
    "isDst": false,
    "timestamp": 1504400400,
    "region": "Africa",
    "displayName": "Windhoek (Africa +120)"
  },
  {
    "name": "Asia/Beirut",
    "countryCode": "LB",
    "abbreviation": "EET",
    "offsetMinutes": 7200,
    "isDst": false,
    "timestamp": 16719339600,
    "region": "Asia",
    "displayName": "Beirut (Asia +120)"
  },
  {
    "name": "Asia/Famagusta",
    "countryCode": "CY",
    "abbreviation": "EET",
    "offsetMinutes": 7200,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Asia",
    "displayName": "Famagusta (Asia +120)"
  },
  {
    "name": "Asia/Gaza",
    "countryCode": "PS",
    "abbreviation": "EET",
    "offsetMinutes": 7200,
    "isDst": false,
    "timestamp": 16719260400,
    "region": "Asia",
    "displayName": "Gaza (Asia +120)"
  },
  {
    "name": "Asia/Hebron",
    "countryCode": "PS",
    "abbreviation": "EET",
    "offsetMinutes": 7200,
    "isDst": false,
    "timestamp": 16719260400,
    "region": "Asia",
    "displayName": "Hebron (Asia +120)"
  },
  {
    "name": "Asia/Jerusalem",
    "countryCode": "IL",
    "abbreviation": "IST",
    "offsetMinutes": 7200,
    "isDst": false,
    "timestamp": 16719346800,
    "region": "Asia",
    "displayName": "Jerusalem (Asia +120)"
  },
  {
    "name": "Asia/Nicosia",
    "countryCode": "CY",
    "abbreviation": "EET",
    "offsetMinutes": 7200,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Asia",
    "displayName": "Nicosia (Asia +120)"
  },
  {
    "name": "Europe/Athens",
    "countryCode": "GR",
    "abbreviation": "EET",
    "offsetMinutes": 7200,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Athens (Europe +120)"
  },
  {
    "name": "Europe/Bucharest",
    "countryCode": "RO",
    "abbreviation": "EET",
    "offsetMinutes": 7200,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Bucharest (Europe +120)"
  },
  {
    "name": "Europe/Chisinau",
    "countryCode": "MD",
    "abbreviation": "EET",
    "offsetMinutes": 7200,
    "isDst": false,
    "timestamp": 16719350400,
    "region": "Europe",
    "displayName": "Chisinau (Europe +120)"
  },
  {
    "name": "Europe/Helsinki",
    "countryCode": "FI",
    "abbreviation": "EET",
    "offsetMinutes": 7200,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Helsinki (Europe +120)"
  },
  {
    "name": "Europe/Kaliningrad",
    "countryCode": "RU",
    "abbreviation": "EET",
    "offsetMinutes": 7200,
    "isDst": false,
    "timestamp": 1414278000,
    "region": "Europe",
    "displayName": "Kaliningrad (Europe +120)"
  },
  {
    "name": "Europe/Kyiv",
    "countryCode": "UA",
    "abbreviation": "EET",
    "offsetMinutes": 7200,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Kyiv (Europe +120)"
  },
  {
    "name": "Europe/Mariehamn",
    "countryCode": "AX",
    "abbreviation": "EET",
    "offsetMinutes": 7200,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Mariehamn (Europe +120)"
  },
  {
    "name": "Europe/Riga",
    "countryCode": "LV",
    "abbreviation": "EET",
    "offsetMinutes": 7200,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Riga (Europe +120)"
  },
  {
    "name": "Europe/Sofia",
    "countryCode": "BG",
    "abbreviation": "EET",
    "offsetMinutes": 7200,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Sofia (Europe +120)"
  },
  {
    "name": "Europe/Tallinn",
    "countryCode": "EE",
    "abbreviation": "EET",
    "offsetMinutes": 7200,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Tallinn (Europe +120)"
  },
  {
    "name": "Europe/Vilnius",
    "countryCode": "LT",
    "abbreviation": "EET",
    "offsetMinutes": 7200,
    "isDst": false,
    "timestamp": 16719354000,
    "region": "Europe",
    "displayName": "Vilnius (Europe +120)"
  },
  {
    "name": "Africa/Addis_Ababa",
    "countryCode": "ET",
    "abbreviation": "EAT",
    "offsetMinutes": 10800,
    "isDst": false,
    "timestamp": -1062210920,
    "region": "Africa",
    "displayName": "Addis Ababa (Africa +180)"
  },
  {
    "name": "Africa/Asmara",
    "countryCode": "ER",
    "abbreviation": "EAT",
    "offsetMinutes": 10800,
    "isDst": false,
    "timestamp": -1062210920,
    "region": "Africa",
    "displayName": "Asmara (Africa +180)"
  },
  {
    "name": "Africa/Dar_es_Salaam",
    "countryCode": "TZ",
    "abbreviation": "EAT",
    "offsetMinutes": 10800,
    "isDst": false,
    "timestamp": -284006700,
    "region": "Africa",
    "displayName": "Dar es Salaam (Africa +180)"
  },
  {
    "name": "Africa/Djibouti",
    "countryCode": "DJ",
    "abbreviation": "EAT",
    "offsetMinutes": 10800,
    "isDst": false,
    "timestamp": -1846291956,
    "region": "Africa",
    "displayName": "Djibouti (Africa +180)"
  },
  {
    "name": "Africa/Kampala",
    "countryCode": "UG",
    "abbreviation": "EAT",
    "offsetMinutes": 10800,
    "isDst": false,
    "timestamp": -410237100,
    "region": "Africa",
    "displayName": "Kampala (Africa +180)"
  },
  {
    "name": "Africa/Mogadishu",
    "countryCode": "SO",
    "abbreviation": "EAT",
    "offsetMinutes": 10800,
    "isDst": false,
    "timestamp": -410236200,
    "region": "Africa",
    "displayName": "Mogadishu (Africa +180)"
  },
  {
    "name": "Africa/Nairobi",
    "countryCode": "KE",
    "abbreviation": "EAT",
    "offsetMinutes": 10800,
    "isDst": false,
    "timestamp": -865305900,
    "region": "Africa",
    "displayName": "Nairobi (Africa +180)"
  },
  {
    "name": "Antarctica/Syowa",
    "countryCode": "AQ",
    "abbreviation": "SYOT",
    "offsetMinutes": 10800,
    "isDst": false,
    "timestamp": -407808000,
    "region": "Antarctica",
    "displayName": "Syowa (Antarctica +180)"
  },
  {
    "name": "Asia/Aden",
    "countryCode": "YE",
    "abbreviation": "AST",
    "offsetMinutes": 10800,
    "isDst": false,
    "timestamp": -631162794,
    "region": "Asia",
    "displayName": "Aden (Asia +180)"
  },
  {
    "name": "Asia/Amman",
    "countryCode": "JO",
    "abbreviation": "EEST",
    "offsetMinutes": 10800,
    "isDst": false,
    "timestamp": 1645740000,
    "region": "Asia",
    "displayName": "Amman (Asia +180)"
  },
  {
    "name": "Asia/Baghdad",
    "countryCode": "IQ",
    "abbreviation": "AST",
    "offsetMinutes": 10800,
    "isDst": false,
    "timestamp": 1191196800,
    "region": "Asia",
    "displayName": "Baghdad (Asia +180)"
  },
  {
    "name": "Asia/Bahrain",
    "countryCode": "BH",
    "abbreviation": "AST",
    "offsetMinutes": 10800,
    "isDst": false,
    "timestamp": 76190400,
    "region": "Asia",
    "displayName": "Bahrain (Asia +180)"
  },
  {
    "name": "Asia/Damascus",
    "countryCode": "SY",
    "abbreviation": "EEST",
    "offsetMinutes": 10800,
    "isDst": false,
    "timestamp": 1648159200,
    "region": "Asia",
    "displayName": "Damascus (Asia +180)"
  },
  {
    "name": "Asia/Kuwait",
    "countryCode": "KW",
    "abbreviation": "AST",
    "offsetMinutes": 10800,
    "isDst": false,
    "timestamp": -631163516,
    "region": "Asia",
    "displayName": "Kuwait (Asia +180)"
  },
  {
    "name": "Asia/Qatar",
    "countryCode": "QA",
    "abbreviation": "AST",
    "offsetMinutes": 10800,
    "isDst": false,
    "timestamp": 76190400,
    "region": "Asia",
    "displayName": "Qatar (Asia +180)"
  },
  {
    "name": "Asia/Riyadh",
    "countryCode": "SA",
    "abbreviation": "AST",
    "offsetMinutes": 10800,
    "isDst": false,
    "timestamp": -719636812,
    "region": "Asia",
    "displayName": "Riyadh (Asia +180)"
  },
  {
    "name": "Europe/Istanbul",
    "countryCode": "TR",
    "abbreviation": "TRT",
    "offsetMinutes": 10800,
    "isDst": false,
    "timestamp": 1473195600,
    "region": "Europe",
    "displayName": "Istanbul (Europe +180)"
  },
  {
    "name": "Europe/Kirov",
    "countryCode": "RU",
    "abbreviation": "MSK",
    "offsetMinutes": 10800,
    "isDst": false,
    "timestamp": 1414274400,
    "region": "Europe",
    "displayName": "Kirov (Europe +180)"
  },
  {
    "name": "Europe/Minsk",
    "countryCode": "BY",
    "abbreviation": "MSK",
    "offsetMinutes": 10800,
    "isDst": false,
    "timestamp": 1301184000,
    "region": "Europe",
    "displayName": "Minsk (Europe +180)"
  },
  {
    "name": "Europe/Moscow",
    "countryCode": "RU",
    "abbreviation": "MSK",
    "offsetMinutes": 10800,
    "isDst": false,
    "timestamp": 1414274400,
    "region": "Europe",
    "displayName": "Moscow (Europe +180)"
  },
  {
    "name": "Europe/Simferopol",
    "countryCode": "UA",
    "abbreviation": "MSK",
    "offsetMinutes": 10800,
    "isDst": false,
    "timestamp": 1414274400,
    "region": "Europe",
    "displayName": "Simferopol (Europe +180)"
  },
  {
    "name": "Europe/Volgograd",
    "countryCode": "RU",
    "abbreviation": "MSK",
    "offsetMinutes": 10800,
    "isDst": false,
    "timestamp": 1609020000,
    "region": "Europe",
    "displayName": "Volgograd (Europe +180)"
  },
  {
    "name": "Indian/Antananarivo",
    "countryCode": "MG",
    "abbreviation": "EAT",
    "offsetMinutes": 10800,
    "isDst": false,
    "timestamp": -492062400,
    "region": "Indian",
    "displayName": "Antananarivo (Indian +180)"
  },
  {
    "name": "Indian/Comoro",
    "countryCode": "KM",
    "abbreviation": "EAT",
    "offsetMinutes": 10800,
    "isDst": false,
    "timestamp": -1846291984,
    "region": "Indian",
    "displayName": "Comoro (Indian +180)"
  },
  {
    "name": "Indian/Mayotte",
    "countryCode": "YT",
    "abbreviation": "EAT",
    "offsetMinutes": 10800,
    "isDst": false,
    "timestamp": -1846292456,
    "region": "Indian",
    "displayName": "Mayotte (Indian +180)"
  },
  {
    "name": "Asia/Tehran",
    "countryCode": "IR",
    "abbreviation": "IRST",
    "offsetMinutes": 12600,
    "isDst": false,
    "timestamp": 1663788600,
    "region": "Asia",
    "displayName": "Tehran (Asia +210)"
  },
  {
    "name": "Asia/Baku",
    "countryCode": "AZ",
    "abbreviation": "AZT",
    "offsetMinutes": 14400,
    "isDst": false,
    "timestamp": 1445731200,
    "region": "Asia",
    "displayName": "Baku (Asia +240)"
  },
  {
    "name": "Asia/Dubai",
    "countryCode": "AE",
    "abbreviation": "GST",
    "offsetMinutes": 14400,
    "isDst": false,
    "timestamp": -1577936472,
    "region": "Asia",
    "displayName": "Dubai (Asia +240)"
  },
  {
    "name": "Asia/Muscat",
    "countryCode": "OM",
    "abbreviation": "GST",
    "offsetMinutes": 14400,
    "isDst": false,
    "timestamp": -1577937264,
    "region": "Asia",
    "displayName": "Muscat (Asia +240)"
  },
  {
    "name": "Asia/Tbilisi",
    "countryCode": "GE",
    "abbreviation": "GET",
    "offsetMinutes": 14400,
    "isDst": false,
    "timestamp": 1111878000,
    "region": "Asia",
    "displayName": "Tbilisi (Asia +240)"
  },
  {
    "name": "Asia/Yerevan",
    "countryCode": "AM",
    "abbreviation": "AMT",
    "offsetMinutes": 14400,
    "isDst": false,
    "timestamp": 1319925600,
    "region": "Asia",
    "displayName": "Yerevan (Asia +240)"
  },
  {
    "name": "Europe/Astrakhan",
    "countryCode": "RU",
    "abbreviation": "MSK+1",
    "offsetMinutes": 14400,
    "isDst": false,
    "timestamp": 1459033200,
    "region": "Europe",
    "displayName": "Astrakhan (Europe +240)"
  },
  {
    "name": "Europe/Samara",
    "countryCode": "RU",
    "abbreviation": "SAMT",
    "offsetMinutes": 14400,
    "isDst": false,
    "timestamp": 1301180400,
    "region": "Europe",
    "displayName": "Samara (Europe +240)"
  },
  {
    "name": "Europe/Saratov",
    "countryCode": "RU",
    "abbreviation": "MSK+1",
    "offsetMinutes": 14400,
    "isDst": false,
    "timestamp": 1480806000,
    "region": "Europe",
    "displayName": "Saratov (Europe +240)"
  },
  {
    "name": "Europe/Ulyanovsk",
    "countryCode": "RU",
    "abbreviation": "MSK+1",
    "offsetMinutes": 14400,
    "isDst": false,
    "timestamp": 1459033200,
    "region": "Europe",
    "displayName": "Ulyanovsk (Europe +240)"
  },
  {
    "name": "Indian/Mahe",
    "countryCode": "SC",
    "abbreviation": "SCT",
    "offsetMinutes": 14400,
    "isDst": false,
    "timestamp": -1988163708,
    "region": "Indian",
    "displayName": "Mahe (Indian +240)"
  },
  {
    "name": "Indian/Mauritius",
    "countryCode": "MU",
    "abbreviation": "MUT",
    "offsetMinutes": 14400,
    "isDst": false,
    "timestamp": 1238274000,
    "region": "Indian",
    "displayName": "Mauritius (Indian +240)"
  },
  {
    "name": "Indian/Reunion",
    "countryCode": "RE",
    "abbreviation": "RET",
    "offsetMinutes": 14400,
    "isDst": false,
    "timestamp": -1848886912,
    "region": "Indian",
    "displayName": "Reunion (Indian +240)"
  },
  {
    "name": "Asia/Kabul",
    "countryCode": "AF",
    "abbreviation": "AFT",
    "offsetMinutes": 16200,
    "isDst": false,
    "timestamp": -788932800,
    "region": "Asia",
    "displayName": "Kabul (Asia +270)"
  },
  {
    "name": "Antarctica/Mawson",
    "countryCode": "AQ",
    "abbreviation": "MAWT",
    "offsetMinutes": 18000,
    "isDst": false,
    "timestamp": 1255809600,
    "region": "Antarctica",
    "displayName": "Mawson (Antarctica +300)"
  },
  {
    "name": "Antarctica/Vostok",
    "countryCode": "AQ",
    "abbreviation": "VOST",
    "offsetMinutes": 18000,
    "isDst": false,
    "timestamp": 1702839600,
    "region": "Antarctica",
    "displayName": "Vostok (Antarctica +300)"
  },
  {
    "name": "Asia/Almaty",
    "countryCode": "KZ",
    "abbreviation": "ALMT",
    "offsetMinutes": 18000,
    "isDst": false,
    "timestamp": 1709229600,
    "region": "Asia",
    "displayName": "Almaty (Asia +300)"
  },
  {
    "name": "Asia/Aqtau",
    "countryCode": "KZ",
    "abbreviation": "AQTT",
    "offsetMinutes": 18000,
    "isDst": false,
    "timestamp": 1099173600,
    "region": "Asia",
    "displayName": "Aqtau (Asia +300)"
  },
  {
    "name": "Asia/Aqtobe",
    "countryCode": "KZ",
    "abbreviation": "AQTT",
    "offsetMinutes": 18000,
    "isDst": false,
    "timestamp": 1099170000,
    "region": "Asia",
    "displayName": "Aqtobe (Asia +300)"
  },
  {
    "name": "Asia/Ashgabat",
    "countryCode": "TM",
    "abbreviation": "TMT",
    "offsetMinutes": 18000,
    "isDst": false,
    "timestamp": 695772000,
    "region": "Asia",
    "displayName": "Ashgabat (Asia +300)"
  },
  {
    "name": "Asia/Atyrau",
    "countryCode": "KZ",
    "abbreviation": "AQTT",
    "offsetMinutes": 18000,
    "isDst": false,
    "timestamp": 1099173600,
    "region": "Asia",
    "displayName": "Atyrau (Asia +300)"
  },
  {
    "name": "Asia/Dushanbe",
    "countryCode": "TJ",
    "abbreviation": "TJT",
    "offsetMinutes": 18000,
    "isDst": false,
    "timestamp": 684363600,
    "region": "Asia",
    "displayName": "Dushanbe (Asia +300)"
  },
  {
    "name": "Asia/Karachi",
    "countryCode": "PK",
    "abbreviation": "PKT",
    "offsetMinutes": 18000,
    "isDst": false,
    "timestamp": 1257012000,
    "region": "Asia",
    "displayName": "Karachi (Asia +300)"
  },
  {
    "name": "Asia/Oral",
    "countryCode": "KZ",
    "abbreviation": "ORAT",
    "offsetMinutes": 18000,
    "isDst": false,
    "timestamp": 1099173600,
    "region": "Asia",
    "displayName": "Oral (Asia +300)"
  },
  {
    "name": "Asia/Qostanay",
    "countryCode": "KZ",
    "abbreviation": "ALMT",
    "offsetMinutes": 18000,
    "isDst": false,
    "timestamp": 1709229600,
    "region": "Asia",
    "displayName": "Qostanay (Asia +300)"
  },
  {
    "name": "Asia/Qyzylorda",
    "countryCode": "KZ",
    "abbreviation": "MSK+2",
    "offsetMinutes": 18000,
    "isDst": false,
    "timestamp": 1545328800,
    "region": "Asia",
    "displayName": "Qyzylorda (Asia +300)"
  },
  {
    "name": "Asia/Samarkand",
    "countryCode": "UZ",
    "abbreviation": "UZT",
    "offsetMinutes": 18000,
    "isDst": false,
    "timestamp": 686091600,
    "region": "Asia",
    "displayName": "Samarkand (Asia +300)"
  },
  {
    "name": "Asia/Tashkent",
    "countryCode": "UZ",
    "abbreviation": "UZT",
    "offsetMinutes": 18000,
    "isDst": false,
    "timestamp": 686091600,
    "region": "Asia",
    "displayName": "Tashkent (Asia +300)"
  },
  {
    "name": "Asia/Yekaterinburg",
    "countryCode": "RU",
    "abbreviation": "YEKT",
    "offsetMinutes": 18000,
    "isDst": false,
    "timestamp": 1414267200,
    "region": "Asia",
    "displayName": "Yekaterinburg (Asia +300)"
  },
  {
    "name": "Indian/Kerguelen",
    "countryCode": "TF",
    "abbreviation": "TFT",
    "offsetMinutes": 18000,
    "isDst": false,
    "timestamp": -631152000,
    "region": "Indian",
    "displayName": "Kerguelen (Indian +300)"
  },
  {
    "name": "Indian/Maldives",
    "countryCode": "MV",
    "abbreviation": "MVT",
    "offsetMinutes": 18000,
    "isDst": false,
    "timestamp": -315636840,
    "region": "Indian",
    "displayName": "Maldives (Indian +300)"
  },
  {
    "name": "Asia/Colombo",
    "countryCode": "LK",
    "abbreviation": "IST",
    "offsetMinutes": 19800,
    "isDst": false,
    "timestamp": 1145039400,
    "region": "Asia",
    "displayName": "Colombo (Asia +330)"
  },
  {
    "name": "Asia/Kolkata",
    "countryCode": "IN",
    "abbreviation": "IST",
    "offsetMinutes": 19800,
    "isDst": false,
    "timestamp": -764145000,
    "region": "Asia",
    "displayName": "Kolkata (Asia +330)"
  },
  {
    "name": "Asia/Kathmandu",
    "countryCode": "NP",
    "abbreviation": "NPT",
    "offsetMinutes": 20700,
    "isDst": false,
    "timestamp": 504901800,
    "region": "Asia",
    "displayName": "Kathmandu (Asia +345)"
  },
  {
    "name": "Asia/Bishkek",
    "countryCode": "KG",
    "abbreviation": "KGT",
    "offsetMinutes": 21600,
    "isDst": false,
    "timestamp": 1123783200,
    "region": "Asia",
    "displayName": "Bishkek (Asia +360)"
  },
  {
    "name": "Asia/Dhaka",
    "countryCode": "BD",
    "abbreviation": "BST",
    "offsetMinutes": 21600,
    "isDst": false,
    "timestamp": 1262278800,
    "region": "Asia",
    "displayName": "Dhaka (Asia +360)"
  },
  {
    "name": "Asia/Omsk",
    "countryCode": "RU",
    "abbreviation": "OMST",
    "offsetMinutes": 21600,
    "isDst": false,
    "timestamp": 1414263600,
    "region": "Asia",
    "displayName": "Omsk (Asia +360)"
  },
  {
    "name": "Asia/Thimphu",
    "countryCode": "BT",
    "abbreviation": "BTT",
    "offsetMinutes": 21600,
    "isDst": false,
    "timestamp": 560025000,
    "region": "Asia",
    "displayName": "Thimphu (Asia +360)"
  },
  {
    "name": "Asia/Urumqi",
    "countryCode": "CN",
    "abbreviation": "URUT",
    "offsetMinutes": 21600,
    "isDst": false,
    "timestamp": -1325483420,
    "region": "Asia",
    "displayName": "Urumqi (Asia +360)"
  },
  {
    "name": "Indian/Chagos",
    "countryCode": "IO",
    "abbreviation": "IOT",
    "offsetMinutes": 21600,
    "isDst": false,
    "timestamp": 820436400,
    "region": "Indian",
    "displayName": "Chagos (Indian +360)"
  },
  {
    "name": "Asia/Yangon",
    "countryCode": "MM",
    "abbreviation": "MMT",
    "offsetMinutes": 23400,
    "isDst": false,
    "timestamp": -778410000,
    "region": "Asia",
    "displayName": "Yangon (Asia +390)"
  },
  {
    "name": "Indian/Cocos",
    "countryCode": "CC",
    "abbreviation": "CCT",
    "offsetMinutes": 23400,
    "isDst": false,
    "timestamp": -2209012060,
    "region": "Indian",
    "displayName": "Cocos (Indian +390)"
  },
  {
    "name": "Antarctica/Davis",
    "countryCode": "AQ",
    "abbreviation": "DAVT",
    "offsetMinutes": 25200,
    "isDst": false,
    "timestamp": 1329854400,
    "region": "Antarctica",
    "displayName": "Davis (Antarctica +420)"
  },
  {
    "name": "Asia/Bangkok",
    "countryCode": "TH",
    "abbreviation": "ICT",
    "offsetMinutes": 25200,
    "isDst": false,
    "timestamp": -1570084924,
    "region": "Asia",
    "displayName": "Bangkok (Asia +420)"
  },
  {
    "name": "Asia/Barnaul",
    "countryCode": "RU",
    "abbreviation": "MSK+4",
    "offsetMinutes": 25200,
    "isDst": false,
    "timestamp": 1459022400,
    "region": "Asia",
    "displayName": "Barnaul (Asia +420)"
  },
  {
    "name": "Asia/Ho_Chi_Minh",
    "countryCode": "VN",
    "abbreviation": "ICT",
    "offsetMinutes": 25200,
    "isDst": false,
    "timestamp": 171820800,
    "region": "Asia",
    "displayName": "Ho Chi Minh (Asia +420)"
  },
  {
    "name": "Asia/Hovd",
    "countryCode": "MN",
    "abbreviation": "HOVT",
    "offsetMinutes": 25200,
    "isDst": false,
    "timestamp": 1474646400,
    "region": "Asia",
    "displayName": "Hovd (Asia +420)"
  },
  {
    "name": "Asia/Jakarta",
    "countryCode": "ID",
    "abbreviation": "WIB",
    "offsetMinutes": 25200,
    "isDst": false,
    "timestamp": -189415800,
    "region": "Asia",
    "displayName": "Jakarta (Asia +420)"
  },
  {
    "name": "Asia/Krasnoyarsk",
    "countryCode": "RU",
    "abbreviation": "KRAT",
    "offsetMinutes": 25200,
    "isDst": false,
    "timestamp": 1414260000,
    "region": "Asia",
    "displayName": "Krasnoyarsk (Asia +420)"
  },
  {
    "name": "Asia/Novokuznetsk",
    "countryCode": "RU",
    "abbreviation": "KRAT",
    "offsetMinutes": 25200,
    "isDst": false,
    "timestamp": 1301169600,
    "region": "Asia",
    "displayName": "Novokuznetsk (Asia +420)"
  },
  {
    "name": "Asia/Novosibirsk",
    "countryCode": "RU",
    "abbreviation": "NOVT",
    "offsetMinutes": 25200,
    "isDst": false,
    "timestamp": 1469304000,
    "region": "Asia",
    "displayName": "Novosibirsk (Asia +420)"
  },
  {
    "name": "Asia/Phnom_Penh",
    "countryCode": "KH",
    "abbreviation": "ICT",
    "offsetMinutes": 25200,
    "isDst": false,
    "timestamp": -767869200,
    "region": "Asia",
    "displayName": "Phnom Penh (Asia +420)"
  },
  {
    "name": "Asia/Pontianak",
    "countryCode": "ID",
    "abbreviation": "WIB",
    "offsetMinutes": 25200,
    "isDst": false,
    "timestamp": 567964800,
    "region": "Asia",
    "displayName": "Pontianak (Asia +420)"
  },
  {
    "name": "Asia/Tomsk",
    "countryCode": "RU",
    "abbreviation": "MSK+4",
    "offsetMinutes": 25200,
    "isDst": false,
    "timestamp": 1464465600,
    "region": "Asia",
    "displayName": "Tomsk (Asia +420)"
  },
  {
    "name": "Asia/Vientiane",
    "countryCode": "LA",
    "abbreviation": "ICT",
    "offsetMinutes": 25200,
    "isDst": false,
    "timestamp": -464428800,
    "region": "Asia",
    "displayName": "Vientiane (Asia +420)"
  },
  {
    "name": "Indian/Christmas",
    "countryCode": "CX",
    "abbreviation": "CXT",
    "offsetMinutes": 25200,
    "isDst": false,
    "timestamp": -2364102172,
    "region": "Indian",
    "displayName": "Christmas (Indian +420)"
  },
  {
    "name": "Antarctica/Casey",
    "countryCode": "AQ",
    "abbreviation": "CAST",
    "offsetMinutes": 28800,
    "isDst": false,
    "timestamp": 1678291200,
    "region": "Antarctica",
    "displayName": "Casey (Antarctica +480)"
  },
  {
    "name": "Asia/Brunei",
    "countryCode": "BN",
    "abbreviation": "BNT",
    "offsetMinutes": 28800,
    "isDst": false,
    "timestamp": -1167636600,
    "region": "Asia",
    "displayName": "Brunei (Asia +480)"
  },
  {
    "name": "Asia/Hong_Kong",
    "countryCode": "HK",
    "abbreviation": "HKT",
    "offsetMinutes": 28800,
    "isDst": false,
    "timestamp": 309292200,
    "region": "Asia",
    "displayName": "Hong Kong (Asia +480)"
  },
  {
    "name": "Asia/Irkutsk",
    "countryCode": "RU",
    "abbreviation": "IRKT",
    "offsetMinutes": 28800,
    "isDst": false,
    "timestamp": 1414256400,
    "region": "Asia",
    "displayName": "Irkutsk (Asia +480)"
  },
  {
    "name": "Asia/Kuala_Lumpur",
    "countryCode": "MY",
    "abbreviation": "MYT",
    "offsetMinutes": 28800,
    "isDst": false,
    "timestamp": 378662400,
    "region": "Asia",
    "displayName": "Kuala Lumpur (Asia +480)"
  },
  {
    "name": "Asia/Kuching",
    "countryCode": "MY",
    "abbreviation": "MYT",
    "offsetMinutes": 28800,
    "isDst": false,
    "timestamp": -767005200,
    "region": "Asia",
    "displayName": "Kuching (Asia +480)"
  },
  {
    "name": "Asia/Macau",
    "countryCode": "MO",
    "abbreviation": "CST",
    "offsetMinutes": 28800,
    "isDst": false,
    "timestamp": 309292200,
    "region": "Asia",
    "displayName": "Macau (Asia +480)"
  },
  {
    "name": "Asia/Makassar",
    "countryCode": "ID",
    "abbreviation": "WITA",
    "offsetMinutes": 28800,
    "isDst": false,
    "timestamp": -766054800,
    "region": "Asia",
    "displayName": "Makassar (Asia +480)"
  },
  {
    "name": "Asia/Manila",
    "countryCode": "PH",
    "abbreviation": "PST",
    "offsetMinutes": 28800,
    "isDst": false,
    "timestamp": 649177200,
    "region": "Asia",
    "displayName": "Manila (Asia +480)"
  },
  {
    "name": "Asia/Shanghai",
    "countryCode": "CN",
    "abbreviation": "CST",
    "offsetMinutes": 28800,
    "isDst": false,
    "timestamp": 684867600,
    "region": "Asia",
    "displayName": "Shanghai (Asia +480)"
  },
  {
    "name": "Asia/Singapore",
    "countryCode": "SG",
    "abbreviation": "SGT",
    "offsetMinutes": 28800,
    "isDst": false,
    "timestamp": 378662400,
    "region": "Asia",
    "displayName": "Singapore (Asia +480)"
  },
  {
    "name": "Asia/Taipei",
    "countryCode": "TW",
    "abbreviation": "CST",
    "offsetMinutes": 28800,
    "isDst": false,
    "timestamp": 307551600,
    "region": "Asia",
    "displayName": "Taipei (Asia +480)"
  },
  {
    "name": "Asia/Ulaanbaatar",
    "countryCode": "MN",
    "abbreviation": "ULAT",
    "offsetMinutes": 28800,
    "isDst": false,
    "timestamp": 1474642800,
    "region": "Asia",
    "displayName": "Ulaanbaatar (Asia +480)"
  },
  {
    "name": "Australia/Perth",
    "countryCode": "AU",
    "abbreviation": "AWST",
    "offsetMinutes": 28800,
    "isDst": false,
    "timestamp": 1238263200,
    "region": "Australia",
    "displayName": "Perth (Australia +480)"
  },
  {
    "name": "Australia/Eucla",
    "countryCode": "AU",
    "abbreviation": "ACWST",
    "offsetMinutes": 31500,
    "isDst": false,
    "timestamp": 1238260500,
    "region": "Australia",
    "displayName": "Eucla (Australia +525)"
  },
  {
    "name": "Asia/Chita",
    "countryCode": "RU",
    "abbreviation": "YAKT",
    "offsetMinutes": 32400,
    "isDst": false,
    "timestamp": 1459015200,
    "region": "Asia",
    "displayName": "Chita (Asia +540)"
  },
  {
    "name": "Asia/Dili",
    "countryCode": "TL",
    "abbreviation": "TLT",
    "offsetMinutes": 32400,
    "isDst": false,
    "timestamp": 969120000,
    "region": "Asia",
    "displayName": "Dili (Asia +540)"
  },
  {
    "name": "Asia/Jayapura",
    "countryCode": "ID",
    "abbreviation": "WIT",
    "offsetMinutes": 32400,
    "isDst": false,
    "timestamp": -189423000,
    "region": "Asia",
    "displayName": "Jayapura (Asia +540)"
  },
  {
    "name": "Asia/Khandyga",
    "countryCode": "RU",
    "abbreviation": "YAKT",
    "offsetMinutes": 32400,
    "isDst": false,
    "timestamp": 1414252800,
    "region": "Asia",
    "displayName": "Khandyga (Asia +540)"
  },
  {
    "name": "Asia/Pyongyang",
    "countryCode": "KP",
    "abbreviation": "KST",
    "offsetMinutes": 32400,
    "isDst": false,
    "timestamp": 1525446000,
    "region": "Asia",
    "displayName": "Pyongyang (Asia +540)"
  },
  {
    "name": "Asia/Seoul",
    "countryCode": "KR",
    "abbreviation": "KST",
    "offsetMinutes": 32400,
    "isDst": false,
    "timestamp": 592333200,
    "region": "Asia",
    "displayName": "Seoul (Asia +540)"
  },
  {
    "name": "Asia/Tokyo",
    "countryCode": "JP",
    "abbreviation": "JST",
    "offsetMinutes": 32400,
    "isDst": false,
    "timestamp": -577962000,
    "region": "Asia",
    "displayName": "Tokyo (Asia +540)"
  },
  {
    "name": "Asia/Yakutsk",
    "countryCode": "RU",
    "abbreviation": "YAKT",
    "offsetMinutes": 32400,
    "isDst": false,
    "timestamp": 1414252800,
    "region": "Asia",
    "displayName": "Yakutsk (Asia +540)"
  },
  {
    "name": "Pacific/Palau",
    "countryCode": "PW",
    "abbreviation": "9",
    "offsetMinutes": 32400,
    "isDst": false,
    "timestamp": -2177485076,
    "region": "Pacific",
    "displayName": "Palau (Pacific +540)"
  },
  {
    "name": "Australia/Darwin",
    "countryCode": "AU",
    "abbreviation": "ACST",
    "offsetMinutes": 34200,
    "isDst": false,
    "timestamp": -813223800,
    "region": "Australia",
    "displayName": "Darwin (Australia +570)"
  },
  {
    "name": "Antarctica/DumontDUrville",
    "countryCode": "AQ",
    "abbreviation": "DDUT",
    "offsetMinutes": 36000,
    "isDst": false,
    "timestamp": -415497600,
    "region": "Antarctica",
    "displayName": "DumontDUrville (Antarctica +600)"
  },
  {
    "name": "Asia/Ust-Nera",
    "countryCode": "RU",
    "abbreviation": "VLAT",
    "offsetMinutes": 36000,
    "isDst": false,
    "timestamp": 1414249200,
    "region": "Asia",
    "displayName": "Ust-Nera (Asia +600)"
  },
  {
    "name": "Asia/Vladivostok",
    "countryCode": "RU",
    "abbreviation": "VLAT",
    "offsetMinutes": 36000,
    "isDst": false,
    "timestamp": 1414249200,
    "region": "Asia",
    "displayName": "Vladivostok (Asia +600)"
  },
  {
    "name": "Australia/Brisbane",
    "countryCode": "AU",
    "abbreviation": "AEST",
    "offsetMinutes": 36000,
    "isDst": false,
    "timestamp": 699379200,
    "region": "Australia",
    "displayName": "Brisbane (Australia +600)"
  },
  {
    "name": "Australia/Lindeman",
    "countryCode": "AU",
    "abbreviation": "AEST",
    "offsetMinutes": 36000,
    "isDst": false,
    "timestamp": 762883200,
    "region": "Australia",
    "displayName": "Lindeman (Australia +600)"
  },
  {
    "name": "Pacific/Chuuk",
    "countryCode": "FM",
    "abbreviation": "CHUT",
    "offsetMinutes": 36000,
    "isDst": false,
    "timestamp": -770634000,
    "region": "Pacific",
    "displayName": "Chuuk (Pacific +600)"
  },
  {
    "name": "Pacific/Guam",
    "countryCode": "GU",
    "abbreviation": "ChST",
    "offsetMinutes": 36000,
    "isDst": false,
    "timestamp": 977493600,
    "region": "Pacific",
    "displayName": "Guam (Pacific +600)"
  },
  {
    "name": "Pacific/Port_Moresby",
    "countryCode": "PG",
    "abbreviation": "PGT",
    "offsetMinutes": 36000,
    "isDst": false,
    "timestamp": -2366790512,
    "region": "Pacific",
    "displayName": "Port Moresby (Pacific +600)"
  },
  {
    "name": "Pacific/Saipan",
    "countryCode": "MP",
    "abbreviation": "ChST",
    "offsetMinutes": 36000,
    "isDst": false,
    "timestamp": 977493600,
    "region": "Pacific",
    "displayName": "Saipan (Pacific +600)"
  },
  {
    "name": "Australia/Adelaide",
    "countryCode": "AU",
    "abbreviation": "ACDT",
    "offsetMinutes": 37800,
    "isDst": false,
    "timestamp": 16717509000,
    "region": "Australia",
    "displayName": "Adelaide (Australia +630)"
  },
  {
    "name": "Australia/Broken_Hill",
    "countryCode": "AU",
    "abbreviation": "ACDT",
    "offsetMinutes": 37800,
    "isDst": false,
    "timestamp": 16717509000,
    "region": "Australia",
    "displayName": "Broken Hill (Australia +630)"
  },
  {
    "name": "Antarctica/Macquarie",
    "countryCode": "AU",
    "abbreviation": "AEDT",
    "offsetMinutes": 39600,
    "isDst": false,
    "timestamp": 16717507200,
    "region": "Antarctica",
    "displayName": "Macquarie (Antarctica +660)"
  },
  {
    "name": "Asia/Magadan",
    "countryCode": "RU",
    "abbreviation": "MAGT",
    "offsetMinutes": 39600,
    "isDst": false,
    "timestamp": 1461427200,
    "region": "Asia",
    "displayName": "Magadan (Asia +660)"
  },
  {
    "name": "Asia/Sakhalin",
    "countryCode": "RU",
    "abbreviation": "SAKT",
    "offsetMinutes": 39600,
    "isDst": false,
    "timestamp": 1459008000,
    "region": "Asia",
    "displayName": "Sakhalin (Asia +660)"
  },
  {
    "name": "Asia/Srednekolymsk",
    "countryCode": "RU",
    "abbreviation": "SRET",
    "offsetMinutes": 39600,
    "isDst": false,
    "timestamp": 1414245600,
    "region": "Asia",
    "displayName": "Srednekolymsk (Asia +660)"
  },
  {
    "name": "Australia/Hobart",
    "countryCode": "AU",
    "abbreviation": "AEDT",
    "offsetMinutes": 39600,
    "isDst": false,
    "timestamp": 16717507200,
    "region": "Australia",
    "displayName": "Hobart (Australia +660)"
  },
  {
    "name": "Australia/Lord_Howe",
    "countryCode": "AU",
    "abbreviation": "LHDT",
    "offsetMinutes": 39600,
    "isDst": false,
    "timestamp": 16717505400,
    "region": "Australia",
    "displayName": "Lord Howe (Australia +660)"
  },
  {
    "name": "Australia/Melbourne",
    "countryCode": "AU",
    "abbreviation": "AEDT",
    "offsetMinutes": 39600,
    "isDst": false,
    "timestamp": 16717507200,
    "region": "Australia",
    "displayName": "Melbourne (Australia +660)"
  },
  {
    "name": "Australia/Sydney",
    "countryCode": "AU",
    "abbreviation": "AEDT",
    "offsetMinutes": 39600,
    "isDst": false,
    "timestamp": 16717507200,
    "region": "Australia",
    "displayName": "Sydney (Australia +660)"
  },
  {
    "name": "Pacific/Bougainville",
    "countryCode": "PG",
    "abbreviation": "BST",
    "offsetMinutes": 39600,
    "isDst": false,
    "timestamp": 1419696000,
    "region": "Pacific",
    "displayName": "Bougainville (Pacific +660)"
  },
  {
    "name": "Pacific/Efate",
    "countryCode": "VU",
    "abbreviation": "VUT",
    "offsetMinutes": 39600,
    "isDst": false,
    "timestamp": 727790400,
    "region": "Pacific",
    "displayName": "Efate (Pacific +660)"
  },
  {
    "name": "Pacific/Guadalcanal",
    "countryCode": "SB",
    "abbreviation": "SBT",
    "offsetMinutes": 39600,
    "isDst": false,
    "timestamp": -1806748788,
    "region": "Pacific",
    "displayName": "Guadalcanal (Pacific +660)"
  },
  {
    "name": "Pacific/Kosrae",
    "countryCode": "FM",
    "abbreviation": "KOST",
    "offsetMinutes": 39600,
    "isDst": false,
    "timestamp": 915105600,
    "region": "Pacific",
    "displayName": "Kosrae (Pacific +660)"
  },
  {
    "name": "Pacific/Noumea",
    "countryCode": "NC",
    "abbreviation": "NCT",
    "offsetMinutes": 39600,
    "isDst": false,
    "timestamp": 857228400,
    "region": "Pacific",
    "displayName": "Noumea (Pacific +660)"
  },
  {
    "name": "Pacific/Pohnpei",
    "countryCode": "FM",
    "abbreviation": "PONT",
    "offsetMinutes": 39600,
    "isDst": false,
    "timestamp": -770634000,
    "region": "Pacific",
    "displayName": "Pohnpei (Pacific +660)"
  },
  {
    "name": "Asia/Anadyr",
    "countryCode": "RU",
    "abbreviation": "ANAT",
    "offsetMinutes": 43200,
    "isDst": false,
    "timestamp": 1301151600,
    "region": "Asia",
    "displayName": "Anadyr (Asia +720)"
  },
  {
    "name": "Asia/Kamchatka",
    "countryCode": "RU",
    "abbreviation": "PETT",
    "offsetMinutes": 43200,
    "isDst": false,
    "timestamp": 1301151600,
    "region": "Asia",
    "displayName": "Kamchatka (Asia +720)"
  },
  {
    "name": "Pacific/Fiji",
    "countryCode": "FJ",
    "abbreviation": "FJT",
    "offsetMinutes": 43200,
    "isDst": false,
    "timestamp": 1610805600,
    "region": "Pacific",
    "displayName": "Fiji (Pacific +720)"
  },
  {
    "name": "Pacific/Funafuti",
    "countryCode": "TV",
    "abbreviation": "TVT",
    "offsetMinutes": 43200,
    "isDst": false,
    "timestamp": -2177495812,
    "region": "Pacific",
    "displayName": "Funafuti (Pacific +720)"
  },
  {
    "name": "Pacific/Kwajalein",
    "countryCode": "MH",
    "abbreviation": "12",
    "offsetMinutes": 43200,
    "isDst": false,
    "timestamp": 745934400,
    "region": "Pacific",
    "displayName": "Kwajalein (Pacific +720)"
  },
  {
    "name": "Pacific/Majuro",
    "countryCode": "MH",
    "abbreviation": "12",
    "offsetMinutes": 43200,
    "isDst": false,
    "timestamp": -7988400,
    "region": "Pacific",
    "displayName": "Majuro (Pacific +720)"
  },
  {
    "name": "Pacific/Nauru",
    "countryCode": "NR",
    "abbreviation": "NRT",
    "offsetMinutes": 43200,
    "isDst": false,
    "timestamp": 287418600,
    "region": "Pacific",
    "displayName": "Nauru (Pacific +720)"
  },
  {
    "name": "Pacific/Norfolk",
    "countryCode": "NF",
    "abbreviation": "NFDT",
    "offsetMinutes": 43200,
    "isDst": false,
    "timestamp": 16717503600,
    "region": "Pacific",
    "displayName": "Norfolk (Pacific +720)"
  },
  {
    "name": "Pacific/Tarawa",
    "countryCode": "KI",
    "abbreviation": "GILT",
    "offsetMinutes": 43200,
    "isDst": false,
    "timestamp": -2177494324,
    "region": "Pacific",
    "displayName": "Tarawa (Pacific +720)"
  },
  {
    "name": "Pacific/Wake",
    "countryCode": "UM",
    "abbreviation": "WAKT",
    "offsetMinutes": 43200,
    "isDst": false,
    "timestamp": -2177492788,
    "region": "Pacific",
    "displayName": "Wake (Pacific +720)"
  },
  {
    "name": "Pacific/Wallis",
    "countryCode": "WF",
    "abbreviation": "WFT",
    "offsetMinutes": 43200,
    "isDst": false,
    "timestamp": -2177496920,
    "region": "Pacific",
    "displayName": "Wallis (Pacific +720)"
  },
  {
    "name": "Antarctica/McMurdo",
    "countryCode": "AQ",
    "abbreviation": "NZDT",
    "offsetMinutes": 46800,
    "isDst": false,
    "timestamp": 16716895200,
    "region": "Antarctica",
    "displayName": "McMurdo (Antarctica +780)"
  },
  {
    "name": "Pacific/Apia",
    "countryCode": "WS",
    "abbreviation": "WST",
    "offsetMinutes": 46800,
    "isDst": false,
    "timestamp": 1617458400,
    "region": "Pacific",
    "displayName": "Apia (Pacific +780)"
  },
  {
    "name": "Pacific/Auckland",
    "countryCode": "NZ",
    "abbreviation": "NZDT",
    "offsetMinutes": 46800,
    "isDst": false,
    "timestamp": 16716895200,
    "region": "Pacific",
    "displayName": "Auckland (Pacific +780)"
  },
  {
    "name": "Pacific/Fakaofo",
    "countryCode": "TK",
    "abbreviation": "TKT",
    "offsetMinutes": 46800,
    "isDst": false,
    "timestamp": 1325242800,
    "region": "Pacific",
    "displayName": "Fakaofo (Pacific +780)"
  },
  {
    "name": "Pacific/Kanton",
    "countryCode": "KI",
    "abbreviation": "PHOT",
    "offsetMinutes": 46800,
    "isDst": false,
    "timestamp": 788871600,
    "region": "Pacific",
    "displayName": "Kanton (Pacific +780)"
  },
  {
    "name": "Pacific/Tongatapu",
    "countryCode": "TO",
    "abbreviation": "TOT",
    "offsetMinutes": 46800,
    "isDst": false,
    "timestamp": 1484398800,
    "region": "Pacific",
    "displayName": "Tongatapu (Pacific +780)"
  },
  {
    "name": "Pacific/Chatham",
    "countryCode": "NZ",
    "abbreviation": "CHADT",
    "offsetMinutes": 49500,
    "isDst": false,
    "timestamp": 16716895200,
    "region": "Pacific",
    "displayName": "Chatham (Pacific +825)"
  },
  {
    "name": "Pacific/Kiritimati",
    "countryCode": "KI",
    "abbreviation": "LINT",
    "offsetMinutes": 50400,
    "isDst": false,
    "timestamp": 788868000,
    "region": "Pacific",
    "displayName": "Kiritimati (Pacific +840)"
  }
]
export class HcScheduleUtil {
  /**
   * Converts all local times in the schedule to their UTC equivalents
   * and populates the utcHour and utcMinute fields in each TimeSlot
   */
  static convertToUtc(schedule: HcSchedule): HcSchedule {
    const convertedSchedule: HcSchedule = {
      ...schedule,
      times: schedule.times.map(timeSlot => this.convertTimeSlotToUtc(timeSlot, schedule.timezone))
    };

    return convertedSchedule;
  }

  /**
   * Converts a single TimeSlot from local time (in the given timezone) to UTC.
   * (hour, minute) are interpreted as clock time in that timezone, not server local.
   */
  static convertTimeSlotToUtc(timeSlot: TimeSlot, timezone: string): TimeSlot {
    const utcDate = this.getUtcDateForLocalTimeInTimezone(
      timezone,
      timeSlot.hour,
      timeSlot.minute
    );
    const hourUTC = utcDate.getUTCHours();
    const minuteUTC = utcDate.getUTCMinutes();
    const utcTimeMinutes = hourUTC * 60 + minuteUTC;
    return {
      ...timeSlot,
      utcTimeMinutes,
      hourUTC,
      minuteUTC
    };
  }

  /**
   * Returns the UTC Date for "today in the given timezone" at the given local hour and minute.
   * Uses Intl so result is correct regardless of server timezone.
   * @param referenceDate - optional; if provided, "today" is taken in the timezone for this instant (default: now).
   */
  static getUtcDateForLocalTimeInTimezone(
    timezone: string,
    hour: number,
    minute: number,
    referenceDate: Date = new Date()
  ): Date {
    if (timezone === 'UTC' || timezone === 'GMT') {
      const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'UTC', year: 'numeric', month: '2-digit', day: '2-digit', hour12: false }).formatToParts(referenceDate);
      const get = (type: string) => parseInt(parts.find((p) => p.type === type)?.value ?? '0', 10);
      const y = get('year');
      const m = get('month') - 1;
      const d = get('day');
      return new Date(Date.UTC(y, m, d, hour, minute, 0, 0));
    }
    const tzFormatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: timezone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
    const parts = tzFormatter.formatToParts(referenceDate);
    const get = (type: string) => parseInt(parts.find((p) => p.type === type)?.value ?? '0', 10);
    const tzYear = get('year');
    const tzMonth = get('month') - 1;
    const tzDay = get('day');
    const localAsUtc = Date.UTC(tzYear, tzMonth, tzDay, hour, minute, 0, 0);
    const offsetMs = this.getTimezoneOffsetMsAt(timezone, new Date(localAsUtc));
    return new Date(localAsUtc - offsetMs);
  }

  /**
   * Offset in ms (TZ - UTC) at the given UTC instant. Positive when TZ is ahead of UTC.
   * So UTC + offsetMs = "display value" when shown in TZ.
   */
  private static getTimezoneOffsetMsAt(timezone: string, utcDate: Date): number {
    const formatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: timezone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
    const parts = formatter.formatToParts(utcDate);
    const get = (type: string) => parseInt(parts.find((p) => p.type === type)?.value ?? '0', 10);
    const localAsUtc = Date.UTC(
      get('year'),
      get('month') - 1,
      get('day'),
      get('hour'),
      get('minute'),
      get('second'),
      0
    );
    return localAsUtc - utcDate.getTime();
  }

  /**
   * Validates if a timezone string is valid
   */
  static isValidTimezone(timezone: string): boolean {
    try {
      Intl.DateTimeFormat(undefined, { timeZone: timezone });
      return true;
    } catch (error) {
      return false;
    }
  }

  /**
   * Gets the current UTC offset for a given timezone in minutes
   */
  static getTimezoneOffset(timezone: string): number {
    if (timezone === 'UTC' || timezone === 'GMT') {
      return 0;
    }

    try {
      return this.getTimezoneOffsetMinutes(timezone);
    } catch (error) {
      console.warn(`Invalid timezone: ${timezone}, returning 0 offset`);
      return 0;
    }
  }

  /**
   * Helper method to get timezone offset in minutes
   */
  private static getTimezoneOffsetMinutes(timezone: string): number {
    const now = new Date();
    const utcDate = new Date(now.toLocaleString('en-US', { timeZone: 'UTC' }));
    const targetDate = new Date(now.toLocaleString('en-US', { timeZone: timezone }));
    return (targetDate.getTime() - utcDate.getTime()) / (1000 * 60);
  }

  /**
   * Gets the UTC hour from a TimeSlot's utcTimeMinutes
   */
  static getUtcHour(timeSlot: TimeSlot): number {
    return Math.floor(timeSlot.utcTimeMinutes / 60);
  }

  /**
   * Gets the UTC minute from a TimeSlot's utcTimeMinutes
   */
  static getUtcMinute(timeSlot: TimeSlot): number {
    return timeSlot.utcTimeMinutes % 60;
  }

  /**
   * Creates a TimeSlot with UTC time for a specific date.
   * (hour, minute) are interpreted as local time in the given timezone on that date.
   */
  static createTimeSlotForDate(hour: number, minute: number, timezone: string, date: Date = new Date()): TimeSlot {
    const utcDate = this.getUtcDateForLocalTimeInTimezone(timezone, hour, minute, date);
    const hourUTC = utcDate.getUTCHours();
    const minuteUTC = utcDate.getUTCMinutes();
    const utcTimeMinutes = hourUTC * 60 + minuteUTC;
    return {
      hour,
      minute,
      utcTimeMinutes,
      hourUTC,
      minuteUTC
    };
  }

  /**
   * Gets the current UTC time in minutes since midnight
   */
  static getCurrentUtcTimeMinutes(): number {
    const now = new Date();
    return now.getUTCHours() * 60 + now.getUTCMinutes();
  }

  /**
   * Checks if a TimeSlot should run at the current UTC time (within a window)
   */
  static shouldRunNow(timeSlot: TimeSlot, windowMinutes = 5): boolean {
    const currentUtcMinutes = this.getCurrentUtcTimeMinutes();
    const timeDiff = Math.abs(currentUtcMinutes - timeSlot.utcTimeMinutes);

    // Handle day boundary (e.g., 23:59 vs 00:01)
    const minDiff = Math.min(timeDiff, 1440 - timeDiff);

    return minDiff <= windowMinutes;
  }

  /**
   * Gets all TimeSlots that should run now from a schedule
   */
  static getTimeSlotsToRunNow(schedule: HcSchedule): TimeSlot[] {
    return schedule.times.filter(timeSlot => this.shouldRunNow(timeSlot, schedule.window));
  }

  /**
   * Formats utcTimeMinutes to HH:MM string
   */
  static formatUtcTime(utcTimeMinutes: number): string {
    const hours = Math.floor(utcTimeMinutes / 60);
    const minutes = utcTimeMinutes % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  }


  /**
   * Returns structured timezone information
   * Includes display names, regions, and current offset information
   */
  static getAllTimezoneInfos(): TimezoneInfo[] {
    return TIMEZONE_DATA;
  }

}
